<template>
    <div id="tradeMainForm">
        <div class="card-body">
            <div class="e-card">
                <div class="e-card-header">
                    <div class="e-card-header-caption">
                        <h4>{{title}}</h4>
                    </div>
                </div>
                <div class="e-card-content">
                </div>
            </div>
            <br />
            <div class="e-card">
                <div class="e-card-header">
                    <div class="e-card-header-caption">
                        <h5>Contract</h5>
                    </div>
                </div>

                <div class="e-card-content">
                    <div class="form-row">
                        <div id="divRadioButtonsClientTradingGroup" class="form-group col-md-12 d-flex justify-content-center input-group" style="display:none!important">
                            <ejs-radiobutton label='Client' id="rbClient" name='default' checked=true @click.native="tradeClientTradingGroupChanged(true)"></ejs-radiobutton>
                            <ejs-radiobutton label='Trading Group' id="rbTreadingGroup" name='default' @click.native="tradeClientTradingGroupChanged(false)"></ejs-radiobutton>
                        </div>

                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                            <ejs-dropdownlist id="clients" name="clients" ref="dplClients" v-model="selectedClientId" :dataSource='clients' :fields="simpleDropdownFields" :select='onClientChange' placeholder="Client" width="60%" floatLabelType='Always' :enabled="clientsEnabled && !isEditing" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group">
                            <ejs-dropdownlist id="tradingGroups" name="tradingGroups" ref="dplTradingGroups" v-model="selectedTradingGroupId" :dataSource='tradingGroups' :enabled='tradingGroupsEnabled && !isEditing' :fields="simpleDropdownFields" :select='onTradingGroupChange' placeholder="Trading Group" width="60%" floatLabelType='Always' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                            <ejs-dropdownlist id="states" name="states" ref="dplStates" v-model="selectedStateId" :dataSource='states' :enabled='statesEnabled && !isEditing' :fields="simpleDropdownFields" :select='onStateChange' placeholder="Country" width="60%" floatLabelType='Always' :allowFiltering='allowFiltering' :actionComplete="actionCompleteDropState" :showClearButton='true'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                            <ejs-dropdownlist id="utilities" name="utilities" ref="dplUtilities" v-model="selectedUtilityTypeId" :dataSource='utilities' :enabled='utilitiesEnabled && !isEditing' :fields="{ text: 'utilityTypeName', value: 'utilityTypeId' }" :select='onUtilityChange' placeholder="Utility" width="60%" floatLabelType='Always' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                            <ejs-dropdownlist id="companies" name="companies" ref="dplCompanies" v-model="selectedCompanyId" :dataSource='companies' :enabled='companiesEnabled && !isEditing' :fields="simpleDropdownFields" :select="onCompanyChange" placeholder="Company" width="60%" floatLabelType='Always' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                            <ejs-dropdownlist id="contracts" name="contracts" ref="dplContracts" v-model="selectedContractId" :dataSource='contracts' :enabled='contractsEnabled && !isEditing' :fields="simpleDropdownFields" :select='onContractChange' placeholder="Contract" width="60%" floatLabelType='Always' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div class="e-card" v-show="showTradeSection === true">
                <div class="e-card-header">
                    <div class="e-card-header-caption">
                        <h5>Trade</h5>
                    </div>
                </div>
                <div class="e-card-content">
                    <div class="form-row">
                        <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                            <ejs-dropdownlist id="products" name="products" ref="dplProducts" v-model="selectedProductId" :dataSource='products' :fields="simpleDropdownFields" :select='onProductChange' placeholder="Product" width="60%" floatLabelType='Always' :enabled="!isEditing" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group" v-if="showPriceAreaSection">
                            <ejs-dropdownlist id="priceArea" name="priceArea" ref="dplpriceArea" v-model="selectedPriceAreaId" :dataSource='priceAreas' :fields="simpleDropdownFields" :select='onPriceAreaChange' :enabled="!isEditing" placeholder="Price Area" width="60%" floatLabelType='Always' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group required-input" v-if="showPriceAreaTradePeriodSection">
                            <ejs-dropdownlist id="tradePeriods" name="tradePeriods" ref="dplTradePeriods" v-model="selectedTradeablePeriodId" :dataSource='tradePeriods' :fields="simpleDropdownFields" :select='onTradablePeriodChange' placeholder="Tradeable Period" width="60%" floatLabelType='Always' :enabled="tradePeriodsEnabled" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                    </div>
                    <div class="form-row" v-if="showFormTradePeriodSection">
                        <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                            <ejs-dropdownlist id="tradePeriods" name="tradePeriods" ref="dplTradePeriods" v-model="selectedTradeablePeriodId" :dataSource='tradePeriods' :fields="simpleDropdownFields" :select='onTradablePeriodChange' placeholder="Tradeable Period" width="60%" floatLabelType='Always' :enabled="tradePeriodsEnabled" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group">

                        </div>
                    </div>
                    <div v-show="showTradeSubSection === true">
                        <div class="form-row">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-datepicker id="periodStartDate" name="periodStartDate" ref="dplPeriodStartDate" placeholder="Start Date" floatLabelType='Always' v-model="data.periodStartDate" :firstDayOfWeek="1" :format="dateFormat" width="60%" :enabled="false"></ejs-datepicker>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-datepicker id="periodEndDate" ref="dplPeriodEndDate" placeholder="End Date" v-model="data.periodEndDate" floatLabelType='Always' :firstDayOfWeek="1" :format="dateFormat" width="60%" :enabled="false"></ejs-datepicker>
                            </div>
                        </div>
                        <br />

                        <div class="form-row">
                            <div class="form-group col-md-12 d-flex justify-content-center input-group">
                                <label class="e-float-text" style="text-align:center">Trade Entity Type</label>
                            </div>
                            <br />
                            <br />
                            <div class="form-group col-md-12 d-flex justify-content-center input-group">
                                <ejs-radiobutton id="simpleTradeEntityTypeRadio" name="tradeEntityType" ref="simpleTradeEntityType" label='Simple' checked=true @click.native="tradeEntityTypeChanged(false)"></ejs-radiobutton>
                                <ejs-radiobutton id="complexTradeEntityTypeRadio" name="tradeEntityType" ref="complexTradeEntityType" label='Complex' :disabled="true" @click.native="tradeEntityTypeChanged(true)"></ejs-radiobutton>
                            </div>
                        </div>

                        <div class="form-row" v-show="!showComplex">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <div class="form-row justify-content-center" style="width:60%">
                                    <div class="form-group col-md-9 input-group required-input" style="padding: 0; padding-right: 10px;">
                                        <ejs-numerictextbox id='lockedVolume' name="lockedVolume" ref="ntbLockedVolume" format="n2" :showSpinButton='false' :step="step" floatLabelType="Always" v-model="data.lockedVolume" :focus="numericVolumeFocus" :blur="numericn2Blur" placeholder="Locked Volume" :change="setCalculatedLockedVolume()" :enabled="lockVolumeNtbEnabled"></ejs-numerictextbox>
                                    </div>
                                    <div class="col-md-3" style="padding:0">
                                        <ejs-textbox id='contractTradingUnit' name="contractTradingUnit" floatLabelType="Always" :value="contractTradingUnit.name" placeholder=" " :enabled="false"></ejs-textbox>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <div class="form-row justify-content-center" style="width:60%">
                                    <div class="form-group col-md-9 input-group required-input" style="padding: 0; padding-right: 10px;">
                                        <ejs-numerictextbox id='price1' name="price" ref="ntbPrice" format="n3" floatLabelType="Always" :showSpinButton='false' :step="step" v-model="data.price" :focus="numericPriceFocus" :blur="numericn3Blur" placeholder="Price" :change="setTradedValue" :enabled="allowEdit"></ejs-numerictextbox>
                                    </div>
                                    <div class="col-md-3" style="padding:0">
                                        <ejs-textbox id='priceUnit' name="priceUnit" floatLabelType="Always" :value="priceUnit" placeholder=" " :enabled="false"></ejs-textbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row" v-show="!showComplex">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <div class="form-row justify-content-center" style="width:60%">
                                    <div class="form-group col-md-9" style="padding: 0; padding-right: 10px;">
                                        <ejs-numerictextbox id='calculatedLockedVolume' name="calculatedLockedVolume" :showSpinButton='false' :step="step" format="n2" floatLabelType="Always" :value="calculatedLockedVolume" placeholder=" " :enabled="false"></ejs-numerictextbox>
                                    </div>
                                    <div class="col-md-3" style="padding:0">
                                        <ejs-textbox id='tradingUnitName' name="tradingUnitName" floatLabelType="Always" :value="tradingUnitName" placeholder=" " :enabled="false"></ejs-textbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row" v-show="!showComplex">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <div class="form-row justify-content-center" style="width:60%">
                                    <div class="form-group col-md-9" style="padding: 0; padding-right: 10px;">
                                        <ejs-numerictextbox id='tradedValue' name="tradedValue" floatLabelType="Always" :showSpinButton='false' :step="step" format="n3" :value="tradedValue" placeholder="Traded Value" :enabled="false"></ejs-numerictextbox>
                                    </div>
                                    <div class="col-md-3" style="padding:0">
                                        <ejs-textbox id='tradeCurrency' name="tradeCurrency" floatLabelType="Always" :value="tradeCurrency" placeholder=" " :enabled="false"></ejs-textbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--COMPLEX-->
                        <div class="form-row" v-show="showComplex">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-dropdownlist id="splitPeriodInto" name="splitPeriodInto" ref="dplSplitPeriodInto" v-model="data.splitPeriodIntoId" :dataSource='splitPeriodInto' :fields="simpleDropdownFields" :select='onSplitPeriodIntoChange' placeholder="Split Period Into" width="60%" floatLabelType='Always' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                            </div>
                        </div>
                        <div class="form-row" v-show="showComplex">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <div class="form-row justify-content-center" style="width:60%">
                                    <div class="form-group col-md-9 input-group required-input" style="padding: 0; padding-right: 10px;">
                                        <ejs-numerictextbox id='lockedVolume' name="lockedVolumeComplex" class="lockedVolComplex e-control e-numerictextbox e-lib" :showSpinButton='false' :step="step" format="n2" floatLabelType="Always" v-model="data.lockedVolume" :change="onLockedVolumeChange" :focus="numericVolumeFocus" :blur="numericn2BlurComplex" placeholder="Locked Volume" :enabled="allowEdit"></ejs-numerictextbox>
                                    </div>
                                    <div class="col-md-3" style="padding:0">
                                        <ejs-textbox id='contractTradingUnit' name="contractTradingUnit" floatLabelType="Always" :value="contractTradingUnit.name" placeholder=" " :enabled="false"></ejs-textbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row" v-show="showComplex">
                            <div class="form-group col-md-12 d-flex justify-content-center input-group" style="padding-top:30px;">
                                <ejs-grid ref='grid'
                                          width="80%"
                                          :dataSource='cgTrades'
                                          :allowFiltering='false'
                                          :allowPaging='false'
                                          :allowResizing='false'
                                          :allowReordering='false'
                                          :allowSorting='false'
                                          :allowExcelExport='false'
                                          :allowTextWrap='true'
                                          :actionBegin="actionBegin"
                                          :editSettings='editSettings'>
                                    <e-columns>
                                        <e-column field='id' headerText='Id' :visible='false'></e-column>
                                        <e-column field='periodName' headerText='Tradeable Period' :isPrimaryKey='true' :allowEditing="false"></e-column>
                                        <e-column field='calculatedLockedVolume' headerText='Calculated Volume' type="number" format='N2' :edit="numericParams" editType="numericedit" :allowEditing="false"></e-column>
                                        <e-column field='tradingUnitName' headerText='Volume Unit' :allowEditing="false"></e-column>
                                        <e-column field='price' headerText='Price' :edit="numericParams" format='N3' type="number" :allowEditing="true" editType="numericedit" :validationRules="cgPriceValidationRules"></e-column>
                                        <e-column field='priceUnit' headerText='Trade Unit' :allowEditing="false"></e-column>
                                        <e-column field='volumeHedgedPercentage' headerText='Volume Hedged Percentage' :allowEditing="false" :visible='false'></e-column>
                                        <e-column field='periodStartDate' headerText='Period Start Date' :allowEditing="false" :visible='false' type="date" :format="dateFormat"></e-column>
                                        <e-column field='periodEndDate' headerText='Period End Date' :allowEditing="false" :visible='false' type="date" :format="dateFormat"></e-column>
                                    </e-columns>
                                    <e-aggregates>
                                        <e-aggregate>
                                            <e-columns>
                                                <e-column columnName="calculatedLockedVolume" type="Custom" :customAggregate="customSumFn" :footerTemplate='footerSum'></e-column>
                                            </e-columns>
                                        </e-aggregate>
                                        <e-aggregate>
                                            <e-columns>
                                                <e-column columnName="price" type="Custom" :customAggregate="customAggregateFn" :footerTemplate='footerAverage'></e-column>
                                            </e-columns>
                                        </e-aggregate>
                                    </e-aggregates>
                                </ejs-grid>
                            </div>
                        </div>
                        <!--END COMPLEX-->
                        <div class="form-row" style="padding-top:16px;">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                                <ejs-textbox id='tradedBy' name="tradedBy" width="60%" floatLabelType="Always" v-model="data.tradedBy" placeholder="Traded By" :enabled="tradedbyEnabled"></ejs-textbox>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='confirmationReference' name="confirmationReference" width="60%" floatLabelType="Always" v-model="data.confirmationReference" placeholder="Confirmation Reference"></ejs-textbox>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                                <ejs-datepicker id="tradeDate" name="tradeDate" ref="tradeDate" placeholder="Trade Date" :strictMode="true" floatLabelType="Always" width="60%" v-model="data.tradeDate" :firstDayOfWeek="1" :format="dateFormat" :change="onTradeDateChange" :max='maxTradeDate' :enabled="tradeDateEnabled"></ejs-datepicker>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='supplementaryNote' name="supplementaryNote" width="60%" floatLabelType="Always" v-model="data.supplementaryNote" placeholder="Supplementary Note"></ejs-textbox>
                            </div>
                        </div>
                        <div v-show="!isHypothetical">
                            <div class="form-row">
                                <div class="form-group col-md-12 d-flex justify-content-center input-group">
                                    <ejs-uploader ref="confirmationTradeFiles"
                                                  id='confirmationTradeFiles'
                                                  name="confirmationTradeFiles"
                                                  :asyncSettings="path"
                                                  cssClass="uploder-trade-file"
                                                  :buttons="{browse: 'Upload Confirmation Trade Files'}"
                                                  class="ignore-validation"
                                                  :uploading="addHeaders"
                                                  :success="onUploadSuccess"
                                                  :enabled="true"></ejs-uploader>
                                </div>

                            </div>
                            <div class="form-group col-md-12 d-flex justify-content-center input-group">
                                <ejs-dropdownbutton ref="refDownloadTradeFile" name="btnDownloadTradeFile" :disabled="!isEditing" id="btnDownloadTradeFile" cssClass="e-success alfa-light-purple" :items='tradeFilesItmes' :select="onDownloadTradeFileClick">Download Trade file</ejs-dropdownbutton>
                                <ejs-dropdownbutton ref="refRemoveTradeFile" name="btnRemoveTradeFile" :disabled="false" id="btnRemoveTradeFile" cssClass="e-primary" :items='tradeFilesItmes' :select="onRemoveTradeFileClick">Remove Trade file</ejs-dropdownbutton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="e-card">
            <div class="e-card-content">
                <div class="clientButtons">
                    <div class="form-row">
                        <div class="form-group col-md-6">
                        </div>
                        <div style="text-align: right; margin-top:20px;" class="form-group col-md-6">
                            <ejs-button id="savebutton" v-if="canSave" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnSaveClickTrade' :disabled="isSubmitting">
                                {{ isSubmitting ? "Saving..." : "Save" }}
                            </ejs-button>
                            <ejs-button v-on:click.native='btnBackClick'>Back</ejs-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
    import { RadioButtonPlugin, ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { NumericTextBoxPlugin, TextBoxPlugin, FormValidator, UploaderPlugin } from "@syncfusion/ej2-vue-inputs";
    import { enableRipple } from '@syncfusion/ej2-base';
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import apis from '@/common/network';
    import urls from '@/common/urls';
    import authToken from '@/common/authToken';
    import unitConversions from '@/common/unitConversions';
    import dates from '@/common/dates';
    import tradeHelper from '@/common/tradeHelper';
    import store from '@/store';
    import { v4 as uuidv4 } from 'uuid';
    import RMErrorType from '@/common/errorTypes';

    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, Aggregate  } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import gridOptions from '@/common/gridOptions';
    import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

    enableRipple(true);
    Vue.use(DatePickerPlugin);
    Vue.use(RadioButtonPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(NumericTextBoxPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(DialogPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);
    Vue.use(DropDownButtonPlugin);

    let AlertDialog = undefined;
    let selectedRecord = {};

    export default {
        name: 'TradeForm',
        created() {
            showSpinner(document.getElementById('mainSpinner'));
            let self = this;
            this.populateUtilities();
            this.populateTradingGroups();

            let atgIdRequested;
            let contractIdRequested;
            if (this.$route.params.callerForm =="Reports UI") {
                contractIdRequested = this.$route.params.callerId;
            } else if (this.$route.params.callerForm =="ATGReports") {
                atgIdRequested = parseInt(this.$route.params.callerId);
            }
            if (atgIdRequested) {
                this.selectedTradingGroupId = atgIdRequested;
                this.data.tradingGroupId = atgIdRequested;
                this.tradingGroupsEnabled = false;
                this.clientsEnabled = false;
                this.companiesEnabled = false;
                this.contractsEnabled = false;
                this.data.atgTradeId = uuidv4();
                let url = `utils/tradingGroups`;
                apis.protectedApi(url)
                    .then(response => {
                        this.tradingGroups = response.data;
                        this.selectedTradingGroupId = atgIdRequested;

                        var e = response.data.filter(tg => tg.id === atgIdRequested)[0];
                        this.onTradingGroupChange(e);

                        if (e != null) {
                            this.data.utilityTypeId = e.utilityTypeId;
                            this.selectedUtilityTypeId = e.utilityTypeId;
                            this.selectedTradingGroupId = e.id;
                        }


                    }).catch(e => {
                        if (e.response.data.message) {
                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                            hideSpinner(document.getElementById('mainSpinner'));
                        }
                    });



            }
            if (contractIdRequested) {
                apis.protectedApi(`contract/${contractIdRequested}`)
                    .then(response => {
                        this.allowEdit = true;
                        this.data.clientId = response.data.clientId;
                        this.data.stateId = response.data.stateId;

                        let url = `utils/parentclients?userId=${this.$store.state.loggedInUserId}&clientId=${response.data.clientId}`;
                        apis.protectedApi(url)
                            .then(responseC => {
                                this.clients = responseC.data;
                                setTimeout(() => {
                                    this.selectedClientId = response.data.clientId;
                                }, 1000)

                                let urlcs = `utils/clientStates?clientId=${response.data.clientId}`;
                                apis.protectedApi(urlcs)
                                    .then(responseCs => {
                                        this.states = responseCs.data;
                                        setTimeout(() => {
                                            this.selectedStateId = response.data.stateId;
                                        }, 1000)

                                    }).catch(e => {
                                        if (e.response.data.message) {
                                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                            hideSpinner(document.getElementById('mainSpinner'));
                                        }
                                    });

                            }).catch(e => {
                                if (e.response.data.message) {
                                    this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                    hideSpinner(document.getElementById('mainSpinner'));
                                }
                            });

                        this.utilitiesEnabled = true;
                        this.companiesEnabled = true;
                        this.contractsEnabled = true;
                        this.clientsEnabled = true;
                        //this.statesEnabled = true;
                        this.tradingGroupsEnabled = false;
                        this.resetTrade();

                        //this.data.stateId = response.data.stateId;
                        //this.populateStates(response.data.clientId);
                        //this.selectedStateId = response.data.stateId;

                        this.data.utilityTypeId = response.data.utilityTypeId;
                        this.populateUtilities();
                        this.selectedUtilityTypeId = response.data.utilityTypeId;
                        this.data.companyId = response.data.companyId;
                        this.populateCompanies(response.data.clientId, response.data.stateId);
                        this.data.contractId = response.data.contractId;
                        this.populateContracts(response.data.companyId, response.data.stateId, response.data.utilityTypeId);
                        this.selectedContractApportionmentId = response.data.tradeApportionmentId;

                        this.populateProducts(contractIdRequested, response.data.utilityTypeId);
                        this.populateTradePeriods(contractIdRequested);
                        this.populateVolumes(contractIdRequested);
                        this.tradingGroupsEnabled = false;
                        this.showTradeSection = true;
                        this.showTradeSubSection = false;
                        this.populateTradePeriodSpans();
                        this.disableContractSection();
                        this.populatePriceAreas(response.data.contractId);
                        //populate utility
                        if (this.selectedUtilityTypeId == null) {
                            this.selectedUtilityTypeId = response.data.utilityTypeId;
                        }
                        apis.protectedApi(`utils/contractTradeablePeriods?contractId=${contractIdRequested}`).then(tpResponse => {
                            apis.protectedApi(`volume/Contract/${contractIdRequested}/Open`).then(volumesResponse => {
                                apis.protectedApi(`utils/contractTradingUnit?contractId=${contractIdRequested}`).then(contractTradingUnitResponse => {
                                    apis.protectedApi(`utils/contractVolumeUnit?contractId=${contractIdRequested}`).then(contractVolumeUnitResponse => {

                                        this.contractTradingUnit = contractTradingUnitResponse.data;
                                        this.volumeUnit = contractVolumeUnitResponse.data;
                                        this.selectedVolumeUnitId = contractVolumeUnitResponse.data.id;
                                        this.volumes = volumesResponse.data;
                                        this.tradePeriods = tpResponse.data;
                                    });
                                });
                            });
                        });

                    }).catch(e => {
                        if (e.response && e.response.data) {
                            if (e.response.data.status === 404) {
                                this.showErrorDialog(RMErrorType.recordDoesNotExist, `Error loading base data for trade based on contract id: ` + contractIdRequested);
                                hideSpinner(document.getElementById('mainSpinner'));
                            } else {
                                this.showErrorDialog(RMErrorType.default, e.response.data.message ?? e + 'An unknown error occured, please contact support.');
                                hideSpinner(document.getElementById('mainSpinner'));
                            }
                        }
                    });
            }
            if (this.isEditing == false) {
                this.populateClients(0);
            }else {

                apis.protectedApi(`trade/${this.$route.params.tradeId}`)
                    .then(response => {
                        this.initialLoad = true;
                        this.data = response.data.trade;
                        this.tradeFileUrls = response.data.trade.confirmationTradeUrl ? response.data.trade.confirmationTradeUrl.split(',') : [];
                        this.tradeFilesItmes = this.getTradeUrl(this.tradeFileUrls);
                        this.allowEdit = this.data.atgTradeId ? false : true;
                        this.populateClients(response.data.trade.clientId);
                        this.populateStates(response.data.trade.clientId);
                        this.populateUtilities();
                        this.populateCompanies(response.data.trade.clientId, response.data.trade.stateId);
                        this.selectedContractApportionmentId = response.data.trade.tradeApportionmentId;

                        if (!response.data.trade.tradingGroupId) {
                            this.populateContracts(response.data.trade.companyId, response.data.trade.stateId, response.data.trade.utilityTypeId);
                        } else {
                            this.populateAtgContract(response.data.trade.contractId, response.data.trade.contractName);
                            this.populateTradingGroups();
                        }

                        this.populateProducts(response.data.trade.contractId, response.data.trade.utilityTypeId);
                        this.populateTradePeriodSpans();
                        this.populatePriceAreas(response.data.trade.contractId, null);
                        apis.protectedApi(`utils/contractTradeablePeriods?contractId=${response.data.trade.contractId}`).then(tpResponse => {
                            apis.protectedApi(`volume/Contract/${response.data.trade.contractId}/Open`).then(volumesResponse => {
                                apis.protectedApi(`utils/contractTradingUnit?contractId=${response.data.trade.contractId}`).then(contractTradingUnitResponse => {
                                    apis.protectedApi(`utils/contractVolumeUnit?contractId=${response.data.trade.contractId}`).then(contractVolumeUnitResponse => {
                                        this.calculatedLockedVolume = response.data.trade.calculatedLockedVolume;
                                        this.existingCalculatedLockedVolume = response.data.trade.calculatedLockedVolume;
                                        this.tradedValue = response.data.trade.tradedValue;
                                        this.data.price = response.data.trade.price;
                                        this.priceUnit = response.data.trade.priceUnit;
                                        this.contractTradingUnit = contractTradingUnitResponse.data;
                                        this.selectedTradingUnitId = response.data.trade.tradingUnitId;
                                        this.selectedCurrencyId = response.data.trade.currencyId;
                                        this.tradingUnitName = self.data.tradingUnitName;
                                        this.tradingUnitTradingName = self.data.tradingUnitTradingName;
                                        this.volumeUnit = contractVolumeUnitResponse.data;
                                        this.selectedVolumeUnitId = contractVolumeUnitResponse.data.id;
                                        this.volumes = volumesResponse.data;
                                        this.tradePeriods = tpResponse.data;
                                        setTimeout(() => {
                                            this.selectedTradeablePeriodId = response.data.trade.contractTradeablePeriodId;
                                        }, 1000)
                                        this.volumeInVolumeUnit = self.getProductTotalVolumeByTradeablePeriodId(this.tradePeriods, this.volumes.result, response.data.trade.contractTradeablePeriodId);
                                        setTimeout(() => {
                                            this.selectedProductId = response.data.trade.productId;
                                        }, 1000)
                                        //this.selectedPriceAreaId = response.data.trade.pricingAreaId;
                                        setTimeout(() => {
                                            this.selectedPriceAreaId = response.data.trade.pricingAreaId;
                                        }, 1000)
                                        this.volumes = response.data.trade.pricingAreaId != undefined && response.data.trade.pricingAreaId != null ? this.onPriceAreaChange(null, this.volumes, response.data.trade.pricingAreaId) : this.volumes;
                                        this.calculateTradedVolume(this.tradePeriods, response.data.trade.contractTradeablePeriodId);
                                        self.setCalculatedLockedVolume(this.selectedTradeablePeriodId);
                                        self.setTradedValue();

                                        if (this.selectedTradeablePeriodId) {
                                            this.selectedTradePeriodIndicator = this.tradePeriods.filter(tp => { return tp.id === response.data.trade.contractTradeablePeriodId })[0]['indicator'];
                                        }

                                        this.tradeCurrency = response.data.trade.currencySymbol === 'p' ? JSON.parse(`["\\u${'00A3'}"]`)[0] : response.data.trade.currencySymbol;
                                        this.confirmationTradeFileUrls = response.data.trade.confirmationTradeUrl ? response.data.trade.confirmationTradeUrl.split(',') : [];


                                        this.$refs.simpleTradeEntityType.ej2Instances.disabled = true;
                                        this.$refs.complexTradeEntityType.ej2Instances.disabled = true;
                                        this.$refs.dplTradePeriods.ej2Instances.enabled = false;

                                        if (response.data.complexChildTrades && response.data.complexChildTrades.length) {// load complex trade data
                                            this.$refs.simpleTradeEntityType.ej2Instances.checked = false;
                                            this.$refs.complexTradeEntityType.ej2Instances.checked = true;
                                            this.$refs.complexTradeEntityType.ej2Instances.enabled = true;
                                            this.tradeEntityTypeChanged(true);
                                            this.data.tradeEntityType = 1;
                                            this.cgTrades = response.data.complexChildTrades;
                                            this.existingCgTrades = response.data.complexChildTrades;
                                            this.data.splitPeriodIntoId = response.data.trade.splitPeriodIntoId;
                                            this.$refs.dplSplitPeriodInto.ej2Instances.value = response.data.trade.splitPeriodIntoId;
                                            this.data.splitPeriodIntoId = response.data.trade.splitPeriodIntoId;
                                            this.selectedSplitPeriodInto = response.data.trade.splitPeriodIntoId;

                                        }
                                        if (response.data.isDMAutoFix) {
                                            this.lockVolumeNtbEnabled = false;
                                            this.tradedbyEnabled = false;
                                            this.tradeDateEnabled = false;
                                        }
                                        this.initialLoad = false;
                                    });
                                });
                            });
                        });
                    }).catch(e => {
                        if (e.response && e.response.data) {
                            if (e.response.data.status === 404) {
                                this.showErrorDialog(RMErrorType.recordDoesNotExist, `Trade record with the provided id does not exist.`);
                                hideSpinner(document.getElementById('mainSpinner'));
                            } else {
                                this.showErrorDialog(RMErrorType.default, e.response.data.message ?? e + 'An unknown error occured, please contact support.');
                                hideSpinner(document.getElementById('mainSpinner'));
                            }
                        }
                    });

            }

            hideSpinner(document.getElementById('mainSpinner'));
        },
        mounted() {
            this.tradeForms = new FormValidator("#tradeMainForm", this.options);
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '100',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });

            if (this.isEditing == false && this.$route.params.callerForm != "Reports UI" && this.$route.params.callerForm != "ATGReports") {
                let divRB = document.getElementById("divRadioButtonsClientTradingGroup");
                divRB.style = "display: block;";
            }
        },
        data() {
            return {
                data: {},
                step: 0,
                isSubmitting: false,
                // complex group trades
                cgTrades: [],
                existingCgTrades: [],
                // for every non-monthly trade saved, a monthly trades representation of that trade will also be saved.
                childMonthlyTrades: [],
                clients: [],
                companies: [],
                contracts: [],
                tradeFileUrls: [],
                products: [],
                priceAreas: [],
                states: [],
                tradePeriods: [],
                tradingGroups: [],
                utilities: [],
                volumes: [],
                confirmationTradeFileUrls: [],
                allowEdit: true,
                initialLoad : false,
                clientsEnabled: true,
                companiesEnabled: false,
                lockVolumeNtbEnabled: true,
                tradedbyEnabled: true,
                tradeDateEnabled: true,
                calculatedLockedVolume: 0.0,
                existingCalculatedLockedVolume: 0.0,
                confirmationTradeUrl: null,
                contractsEnabled: false,
                tradePeriodsEnabled: false,
                priceAreaEnabled: true,
                atgVolumesPeriodsPerContract: null,
                showPriceAreaSection: false,
                showPriceAreaTradePeriodSection: true,
                showFormTradePeriodSection: false,
                volumeUnit: null,
                tradingUnitName: null,
                tradingUnitTradingName: null,
                periodEndDate: null,
                periodStartDate: null,
                priceUnit: null,
                ric: null,
                selectedClientId: null,
                selectedCompanyId: null,
                /**
                * if 1 -> Period apportionment
                * else -> Month apportionment
                * @type {number}
                */
                selectedContractApportionmentId: null,
                selectedContractId: null,
                selectedProductId: null,
                selectedPriceAreaId: null,
                selectedProductKey: null,
                selectedSplitPeriodInto: null,
                selectedStateId: null,
                selectedTradePeriodIndicator: null,
                selectedTradeablePeriodId: null,
                selectedTradeablePeriodPeriodId: null,
                selectedTradeablePeriodPeriodSpanId: null,
                selectedTradeablePeriodYear: 0,
                selectedTradingGroupContracts: null,
                selectedTradingGroupId: null,
                selectedUtilityTypeId: null,
                selectedTradingUnitId: null,
                selectedVolumeUnitId: null,
                selectedCurrencyId: null,
                splitPeriodInto: null,
                statesEnabled: false,
                tradeCurrency: null,
                atgTradePeriods: null,
                tradedValue: 0.0,
                tradeForms: null,
                tradePeriodSpans: null,
                tradePeriodVolume: null,
                tradingGroupsEnabled: false,
                tradingUnit: null,
                utilitiesEnabled: false,
                volumeInVolumeUnit: 0.0,
                volumeHedgedPercentage: 0.0,
                contractTradingUnit: '',
                showComplex: false,
                showTradeSection: this.$route.params.tradeId ? true : false,
                showTradeSubSection: this.$route.params.tradeId ? true : false,
                cgPriceValidationRules: { required: true },
                dateFormat: 'dd/MM/yyyy',
                maxDate: new Date(),
                perMonthDistribution : false,
                simpleDropdownFields: { text: 'name', value: 'id' },
                title: this.$route.params.callerTab == "hypothetical" ? "Create HYPOTHETICAL trade": "Create trade",
                isHypothetical: this.$route.params.callerTab == "hypothetical",
                callerForm: this.$route.params.callerForm != undefined ? this.$route.params.callerForm : "Trades",
                callerTab: this.$route.params.callerTab != undefined ? this.$route.params.callerTab : "Trades",
                callerId: this.$route.params.callerId != undefined ? this.$route.params.callerId : 0,
                path: {
                    saveUrl: `${urls.apiBaseUrl}upload/confirmationTrade`,

                },
                splitPeriodIntoBase: [
                    //{
                    //    id: 1,
                    //    name: 'S'
                    //},
                    //{
                    //    id: 2,
                    //    name: 'Q'
                    //},
                    {
                        id: 3,
                        name: 'M'
                    },
                ],
                editSettings: {
                    showConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.Trades.Create"],
                    mode: 'Normal'
                },
                numericParams: {
                    params: {
                        decimals: 4,
                        format: "n4",
                        //min: 0,
                        change: this.complexTradePriceUpdate
                    }
                },
                options: {
                    //Initialize the CustomPlacement.
                    customPlacement: function (inputElement, errorElement) {
                        inputElement = inputElement.closest('.form-group');
                        errorElement.style.width = '60%'
                        inputElement.appendChild(errorElement);
                    },
                    rules: {
                        //'clients': {
                        //    required: true
                        //},
                        'states': {
                            required: true
                        },
                        'utilities': {
                            required: true
                        },
                        'products': {
                            required: true
                        },
                        'tradePeriods': {
                            required: true
                        },
                        'tradeDate': {
                            required: true
                        },
                        'lockedVolume': {
                            required: true
                        },
                        'price': {
                            required: true
                        },
                        'priceArea': {
                            required: false
                        },
                        'tradedBy': {
                            required: true
                        },
                        'tradeDate': {
                            required: true
                        }

                    }

                },
                //canSave: onCanSaveBtn(),
                footerSum: function () {
                    return {
                        template: Vue.component('sumTemplate', {
                            template: `<div><h5>Total: </h5><span>{{data.Custom.toFixed(2)}}</span></div>`,
                            data() { return { data: {} }; }
                        })
                    }
                },
                footerAverage: function () {
                    return {
                        template: Vue.component('averageTemplate', {
                            template: `<div><h5>Avg.: </h5><span>{{data.Custom.toFixed(3)}}</span></div>`,
                            data() { return { data: {} }; }
                        })
                    }
                },
                tradeFilesItmes: [],
                allowFiltering: true,
                maxTradeDate: new Date()

            }
        },
        computed: {
            isSimple: function () {
                return new Query().addParams("userId", this.$store.state.loggedInUserId);
            },
            isEditing: function () {
                if (this.$route.params.tradeId) {
                    return true;
                }
                return false;
            },
            allowEditing: function () {
                return (this.allowEdit && store.state.permissions["Permissions.Trades.Create"]);
            },

            canSave(args) {
                if (this.selectedTradingGroupId && this.$route.params.tradeId) {
                    return false;
                }

                if (this.callerTab == "hypothetical") {
                   return this.$store.state.permissions["Permissions.HypotheticalTrades.Create"]
                } else {
                    return this.$store.state.permissions["Permissions.Trades.Create"]
                }
            },
        },
        methods: {
            onPriceAreaChange: function (args, volume =null, priceAreaId) {
                let volumeDataCreate = new Object();
                volumeDataCreate.count = 0;
                volumeDataCreate.result = new Array();


                this.volumeData = volumeDataCreate; // this volumeData is include in some cases if this.volume is undefined then you can you this to mapp on it.
               //Method for change volume value if Pricing Area is include
                var priceAreaId = priceAreaId == null ? args.itemData.id : priceAreaId;
                if (args !=null && volume == null || volume.result.length > 0 && args == null) {
                    for (var i = 0; i < this.volumes.result.length; i++) {
                        if (this.volumes.result[i].priceAreaVolumes.length > 0) {
                            for (var p = 0; p < this.volumes.result[i].priceAreaVolumes.length; p++) {
                                if (this.volumes.result[i].priceAreaVolumes[p].pricingAreaId == priceAreaId && this.volumes.result[i].priceAreaVolumes[p].volumeId == this.volumes.result[i].volumeId) {

                                    if (this.volumes.result[i].hasOwnProperty('base') && this.volumes.result[i].priceAreaVolumes[p].productName == "Baseload" && this.volumes.result[i].priceAreaVolumes[p].value != 0) {
                                        this.volumes.result[i].base = this.volumes.result[i].priceAreaVolumes[p].value;
                                        this.volumes.result[i].baseOpen = this.volumes.result[i].priceAreaVolumes[p].openVolume;
                                        this.volumes.result[i].total = this.volumes.result[i].base + this.volumes.result[i].peak + this.volumes.result[i].offPeak;
                                        this.volumes.result[i].totalOpen = this.volumes.result[i].baseOpen + this.volumes.result[i].peakOpen + this.volumes.result[i].offPeakOpen;
                                        this.volumeData.result.push(this.volumes.result[i])

                                    }
                                    if (this.volumes.result[i].hasOwnProperty('peak') && this.volumes.result[i].priceAreaVolumes[p].productName == "Peakload" && this.volumes.result[i].priceAreaVolumes[p].value != 0) {
                                        this.volumes.result[i].peak = this.volumes.result[i].priceAreaVolumes[p].value;
                                        this.volumes.result[i].peakOpen = this.volumes.result[i].priceAreaVolumes[p].openVolume;
                                        this.volumes.result[i].total = this.volumes.result[i].base + this.volumes.result[i].peak + this.volumes.result[i].offPeak;
                                        this.volumes.result[i].totalOpen = this.volumes.result[i].baseOpen + this.volumes.result[i].peakOpen + this.volumes.result[i].offPeakOpen;
                                        this.volumeData.result.push(this.volumes.result[i])
                                    }
                                    if (this.volumes.result[i].hasOwnProperty('offPeak') && this.volumes.result[i].priceAreaVolumes[p].productName == "Off-Peak" && this.volumes.result[i].priceAreaVolumes[p].value != 0) {
                                        this.volumes.result[i].offPeak = this.volumes.result[i].priceAreaVolumes[p].value;
                                        this.volumes.result[i].offPeakOpen = this.volumes.result[i].priceAreaVolumes[p].openVolume;
                                        this.volumes.result[i].total = this.volumes.result[i].base + this.volumes.result[i].peak + this.volumes.result[i].offPeak;
                                        this.volumes.result[i].totalOpen = this.volumes.result[i].baseOpen + this.volumes.result[i].peakOpen + this.volumes.result[i].offPeakOpen;
                                        this.volumeData.result.push(this.volumes.result[i])
                                    }
                                    if (this.volumes.result[i].hasOwnProperty('gas') && this.volumes.result[i].priceAreaVolumes[p].productName == "Gas" && this.volumes.result[i].priceAreaVolumes[p].value != 0) {
                                        this.volumes.result[i].gas = this.volumes.result[i].priceAreaVolumes[p].value;
                                        this.volumes.result[i].gasOpen = this.volumes.result[i].priceAreaVolumes[p].openVolume;
                                        this.volumes.result[i].total = this.volumes.result[i].gas;
                                        this.volumes.result[i].totalOpen = this.volumes.result[i].gasOpen;
                                        this.volumeData.result.push(this.volumes.result[i])
                                    }
                                }
                            }


                        } else {
                            this.volumeData.result.push(this.volumes.result[i])
                        }
                    }

                }
                this.volumeData.count = this.volumes.result.length;
                //For case when we have more than one product and multiple areas. Duplicates will be added. This will affect SetCalculatedLockedVolume() function
                //Removing duplicates. Also after reviewing needs to be done on ATG part
                const uniqueValues = new Set();

                this.volumeData.result.forEach(value => {
                    if (!uniqueValues.has(value)) {
                        uniqueValues.add(value);
                    }
                });

                this.volumeData.result.length = 0;
                this.volumeData.result.push(...uniqueValues);



                if (args != null && volume == null || (this.atgVolumesPeriodsPerContract != null && this.atgVolumesPeriodsPerContract.length > 0 && args == null)) {

                    for (var i = 0; i < this.atgVolumesPeriodsPerContract?.length; i++) {

                        if (this.atgVolumesPeriodsPerContract[i].volumes.length > 0) {

                            for (var p = 0; p < this.atgVolumesPeriodsPerContract[i].volumes.length; p++) {

                                if (this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes.length > 0) {
                                    for (var b = 0; b < this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes.length; b++) {
                                        if (this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].pricingAreaId == priceAreaId && this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].volumeId == this.atgVolumesPeriodsPerContract[i].volumes[p].volumeId) {

                                            if (this.atgVolumesPeriodsPerContract[i].volumes[p].hasOwnProperty('base') && this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].productId == 1 && this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].value != 0) {
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].base = this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].value;
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].baseOpen = this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].openVolume;
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].total = this.atgVolumesPeriodsPerContract[i].volumes[p].base + this.atgVolumesPeriodsPerContract[i].volumes[p].peak + this.atgVolumesPeriodsPerContract[i].volumes[p].offPeak;
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].totalOpen = this.atgVolumesPeriodsPerContract[i].volumes[p].baseOpen + this.atgVolumesPeriodsPerContract[i].volumes[p].peakOpen + this.atgVolumesPeriodsPerContract[i].volumes[p].offPeakOpen;

                                            }
                                            if (this.atgVolumesPeriodsPerContract[i].volumes[p].hasOwnProperty('peak') && this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].productId == 2 && this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].value != 0) {
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].peak = this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].value;
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].peakOpen = this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].openVolume;
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].total = this.atgVolumesPeriodsPerContract[i].volumes[p].base + this.atgVolumesPeriodsPerContract.volumes.result[i].peak + this.atgVolumesPeriodsPerContract.volumes.result[i].offPeak;
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].totalOpen = this.atgVolumesPeriodsPerContract[i].volumes[p].baseOpen + this.atgVolumesPeriodsPerContract.volumes.result[i].peakOpen + this.atgVolumesPeriodsPerContract.volumes.result[i].offPeakOpen;

                                            }
                                            if (this.atgVolumesPeriodsPerContract[i].volumes[p].hasOwnProperty('offPeak') && this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].productId == 3 && this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].value != 0) {
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].offPeak = this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].value;
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].offPeakOpen = this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].openVolume;
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].total = this.atgVolumesPeriodsPerContract[i].volumes[p].base + this.atgVolumesPeriodsPerContract.volumes.result[i].peak + this.atgVolumesPeriodsPerContract.volumes.result[i].offPeak;
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].totalOpen = this.atgVolumesPeriodsPerContract[i].volumes[p].baseOpen + this.atgVolumesPeriodsPerContract.volumes.result[i].peakOpen + this.atgVolumesPeriodsPerContract.volumes.result[i].offPeakOpen;

                                            }
                                            if (this.atgVolumesPeriodsPerContract[i].volumes[p].hasOwnProperty('gas') && this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].productId == 4 && this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].value != 0) {
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].gas = this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].value;
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].gasOpen = this.atgVolumesPeriodsPerContract[i].volumes[p].priceAreaVolumes[b].openVolume;
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].total = this.atgVolumesPeriodsPerContract[i].volumes[p].gas;
                                                this.atgVolumesPeriodsPerContract[i].volumes[p].totalOpen = this.atgVolumesPeriodsPerContract[i].volumes[p].gasOpen;

                                            }
                                        }

                                    }
                                }
                                }

                            }
                    }


                }
                setTimeout(function () {
                      document.getElementById("tradePeriods").ej2_instances[0].showPopup();
                }, 500);
        },
            onTradeDateChange: function (args) {
                if (args.isInteracted == true) {
                    if (args.value > new Date()) {
                        let message = { title: 'Warning !', content: `Trade date is future date.`, cssClass: 'e-toast-warning' };
                        this.$root.$emit('showToast', message);
                    }
                }
            },
            getTradeUrl: function (tradeFileUrls) {
                var items = [];
                for (let index in tradeFileUrls) {
                    items.push({ text: tradeFileUrls[index].split(/[\s/]+/).pop().slice(0, -5), id: tradeFileUrls[index] });
                }
                return items;
            },
            actionCompleteDropState(args) {
                if (args.result.length > 0) {
                    if (args.result[0].id != undefined && args.result.length > 0) {
                        for (var i = 0; i < args.result.length; i++) {

                            if (args.result[i].id == this.selectedStateId) {
                                this.$refs.dplStates.$el.value = args.result[i].name;
                                this.selectedStateId = args.result[i].id;
                            }

                        }
                        this.tradeForms.rules.states.required = false;
                        this.$refs.dplStates.$el.ej2_instances[0].isCustomFilter = true;

                    }

                }

            },

            onRemoveTradeFileClick: function (e) {

                if (this.confirmationTradeFileUrls.includes(e.item.id)) {
                    const listUrl = this.confirmationTradeFileUrls;
                    const url = listUrl.indexOf(e.item.id);
                    listUrl.splice(url, 1);

                }
                this.tradeFilesItmes = this.getTradeUrl(this.confirmationTradeFileUrls);
                this.$refs.confirmationTradeFiles.clearAll();
                let message = { title: 'Warning !', content: `Trade file ${e.item.text} removed successfully.`, cssClass: 'e-toast-warning' };
                this.$root.$emit('showToast', message);

            },
            onDownloadTradeFileClick: function (e) {
                const link = document.createElement('a');
                link.href = e.item.id;
                link.click();
            },
            disableContractSection: function () {
                this.statesEnabled = false
                this.utilitiesEnabled = false;
                this.companiesEnabled = false;
                this.contractsEnabled = false;
                this.tradingGroupsEnabled = false;
                this.clientsEnabled = false;
            },

            numericVolumeFocus: function () {
                if (document.getElementById("lockedVolume") != undefined) {
                var field = document.getElementById("lockedVolume").ej2_instances[0];
                    field.format = "n2";
                }
            },
            numericPriceFocus: function () {
                if (document.getElementById("price") != undefined) {
                var field = document.getElementById("price").ej2_instances[0];
                    field.format = "n3";
                }
            },
            numericn2Blur: function () {
                if (document.getElementById("lockedVolume") != undefined) {
                    var lockedVolumeInfo = document.getElementById("lockedVolume-info");
                    var field = document.getElementById("lockedVolume").ej2_instances[0];
                    field.format = "n2";
                    if (field.value != null) {
                        field.value = parseFloat(field.value.toFixed(4));
                        if (lockedVolumeInfo != null) {
                            lockedVolumeInfo.style = "display: none;"
                        }
                    } else {
                        if (lockedVolumeInfo != null) {
                            lockedVolumeInfo.style = "display: block;"
                        }
                    }
                }
            },
            numericn2BlurComplex: function () {
                if (document.getElementsByClassName('lockedVolComplex') != undefined) {
                    var lockedVolumeInfo = document.getElementById("lockedVolumeComplex-info");
                    var field = document.getElementsByClassName('lockedVolComplex').lockedVolume.ej2_instances[0];
                    field.format = "n2";
                    if (field.value != null) {
                        field.value = parseFloat(field.value.toFixed(4));
                        if (lockedVolumeInfo != null) {
                            lockedVolumeInfo.style = "display: none;";

                        }
                    } else {
                        if (lockedVolumeInfo != null) {
                            lockedVolumeInfo.style = "display: block;";
                        }
                    }

                }
            },
            numericn3Blur: function () {
                if (document.getElementById("price1") != undefined) {
                var priceInfo = document.getElementById("price-info");
                var field = document.getElementById("price1").ej2_instances[0];
                    field.format = "n3";
                    if (field.value != null) {
                        field.value = parseFloat(field.value.toFixed(4));

                        if (priceInfo != null) {
                            priceInfo.style = "display: none;"
                        }

                    } else {
                        if (priceInfo != null) {
                            priceInfo.style = "display: block;"
                        }
                    }
                }
            },
            customAggregateFn: function (data) {
                var items = data;
                if (data.result != undefined) {
                    items = data.result;
                }
                var sum = 0;
                var valueSum = 0;
                for (var i = 0; i < items.length; i++) {
                    sum += items[i].calculatedLockedVolume*1; //don't forget to add the base
                    valueSum += items[i].calculatedLockedVolume * parseFloat(items[i].price);
                }

                var avg = valueSum / sum;
                return parseFloat(avg.toFixed(4));
            },
            customSumFn: function (data) {
                var items = data;
                if (data.result != undefined) {
                    items = data.result;
                }
                var valueSum = 0;
                for (var i = 0; i < items.length; i++) {
                    valueSum += items[i].calculatedLockedVolume;
                }
                return parseFloat(valueSum.toFixed(4));
            },
            newCalculatePercentage: function (calculatedLockedVolume, availableVolume, startDate = null, endDate = null, atg = false) {
                if (startDate === null) {
                    startDate = this.data.periodStartDate;
                }
                if (endDate === null) {
                    endDate = this.data.periodEndDate;
                }
                let isPeak = this.$refs.dplProducts.ej2Instances.text == "Peakload";
                let numDays = dates.getDateDiffInDays(startDate, endDate);
                let numBusinessDays = dates.getBusinessDatesCount(startDate, endDate);
                let calculatedLockedVolumeMWh =  unitConversions.convert(
                    calculatedLockedVolume,
                    this.tradingUnitTradingName,
                    'MWh',
                    !isPeak ? numDays : numBusinessDays, isPeak
                );

                let availableVolumeMWh = unitConversions.convert(
                    availableVolume,
                    this.volumeUnit.volumeName,
                    'MWh',
                    !isPeak ? numDays : numBusinessDays, isPeak
                );

                return availableVolumeMWh === 0 ? 0 : (calculatedLockedVolumeMWh / availableVolumeMWh) * 100;
            },
            calculateLockedVolume: function (startDate = null, endDate = null, tradePeriodVolume = null, weightedVolume = 0, lockedVolume = null, cgTrade = null, child = false, parentLockedVolume = null) {


                if (lockedVolume === 0) {
                    return 0;
                }

                if (startDate === null) {
                    startDate = tradeHelper.fixDateOffset(this.data.periodStartDate);
                }
                if (endDate === null) {
                    endDate = tradeHelper.fixDateOffset( this.data.periodEndDate);
                }
                var basePeriod = false;
                if (tradePeriodVolume === null) {
                    tradePeriodVolume = this.tradePeriodVolume;
                    basePeriod = true;
                }
                if (lockedVolume === null) {
                    lockedVolume = this.data.lockedVolume;
                }
                if (parentLockedVolume === null) {
                    parentLockedVolume = this.data.lockedVolume;
                }

                let baseValue = null;
                let result = 0;
                //let self = this;
                let numDays = dates.getDateDiffInDays(startDate, endDate);
                let parentNumDays = dates.getDateDiffInDays(tradeHelper.fixDateOffset(this.data.periodStartDate), tradeHelper.fixDateOffset(this.data.periodEndDate));

                let isPeak = this.$refs.dplProducts && this.products && this.products.filter(p => { return p.name === this.$refs.dplProducts.ej2Instances.text })[0] ?
                    this.products.filter(p => { return p.name === this.$refs.dplProducts.ej2Instances.text })[0].productName == "Peakload" : false;
                let numBusinessDays = dates.getBusinessDatesCount(startDate, endDate);
                let parentnumBusinessDays = dates.getBusinessDatesCount(tradeHelper.fixDateOffset(this.data.periodStartDate), tradeHelper.fixDateOffset( this.data.periodEndDate));

                if (child) {
                    let key = this.getSelectedProductKey();
                    if (['kWh', 'MWh', 'mmbtu', 'therm'].includes(this.contractTradingUnit.tradingName) || (this.contractTradingUnit.tradingName === '%' && this.selectedContractApportionmentId && this.selectedContractApportionmentId === 1)) {
                        result = (this.calculatedLockedVolume / dates.getDateDiffInDays(this.data.periodStartDate, this.data.periodEndDate)) * dates.getDateDiffInDays(startDate, endDate);
                    } else if (this.contractTradingUnit.tradingName === '%' && this.selectedContractApportionmentId && this.selectedContractApportionmentId !== 1) { // % Month
                        var childAvailableVolume = null;
                        if ((cgTrade.periodId && cgTrade.periodId === 2) || cgTrade.splitPeriodIntoId && cgTrade.splitPeriodIntoId === 3) { // it is a monthly period - they are tied to volumes, so cgTrade will be in volume format (see updateChildTradesGridValues)
                            childAvailableVolume = this.volumes.result.filter(v => { return v.volumeId === cgTrade.volumeId })[0];
                        } else {
                            childAvailableVolume = this.getProductTotalVolumeByTradeablePeriodId(this.tradePeriods, this.volumes.result,cgTrade.id);
                        }
                        var childAvailableVolumeInMWh = unitConversions.convert(
                            childAvailableVolume[key],
                            this.volumeUnit.volumeName,
                            'MWh',
                            !isPeak ? numDays : numBusinessDays, isPeak
                        );

                        result = (childAvailableVolumeInMWh * lockedVolume) / 100;
                        result = unitConversions.convert(result, 'MWh',
                            this.tradingUnitTradingName,
                            !isPeak ? numDays : numBusinessDays, isPeak
                        );
                    } else { // th/d //MW
                        result = unitConversions.convert(
                            this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, cgTrade, parentLockedVolume, startDate, endDate, this.selectedContractApportionmentId),
                            this.contractTradingUnit.tradingName, this.tradingUnitTradingName,
                            !isPeak ? numDays : numBusinessDays, isPeak
                        );
                                            }
                } else {
                    if (lockedVolume != 0 && this.contractTradingUnit) {
                        if (this.contractTradingUnit.tradingName === '%') {
                            if (this.perMonthDistribution || basePeriod) {
                                baseValue = unitConversions.percentageToUnit(lockedVolume, tradePeriodVolume);
                            }
                            else {
                                baseValue = unitConversions.percentageToUnit(lockedVolume, weightedVolume);
                            }

                            if (this.tradingUnitTradingName !== this.volumeUnit.volumeName) {
                                result = unitConversions.convert(
                                    baseValue,
                                    this.volumeUnit.volumeName,
                                    this.tradingUnitTradingName,
                                    !isPeak ? numDays : numBusinessDays, isPeak
                                );
                            } else {
                                result = baseValue;
                            }
                        } else {
                            result = unitConversions.convert(
                                lockedVolume,
                                this.contractTradingUnit.tradingName,
                                this.tradingUnitTradingName,
                                !isPeak ? numDays : numBusinessDays, isPeak
                            );
                        }
                    }
                }

                if (result != undefined) {
                    return result;
                }

                return result;
            },
            apportionLockedVolume: function (tradePeriods,volumes,tradingUnit, trade, parentLockedVolume, parentStartDate, parentEndDate, apportionmentId = null) {

                var result = null;
                this.selectedProductKey = this.getSelectedProductKey();
                if (!parentLockedVolume)
                    parentLockedVolume = 0;

                let isPeak = this.$refs.dplProducts.ej2Instances.text == "Peakload";
                var parentNumDays = dates.getDateDiffInDays(parentStartDate, parentEndDate);
                var parentNumBusinessDays = dates.getBusinessDatesCount(parentStartDate, parentEndDate);
                var parentTotalVolume = trade.groupId && !this.isGroupParent || this.showComplex ?
                    this.getProductTotalVolumeByTradeablePeriodId(tradePeriods, volumes, trade.contractTradeablePeriodId ? trade.contractTradeablePeriodId : this.selectedTradeablePeriodId, false, trade.contractId) :
                    this.getProductTotalVolumeByTradeablePeriodId(tradePeriods, volumes, trade.contractTradeablePeriodId ? trade.contractTradeablePeriodId : this.selectedTradeablePeriodId);
                var parentLockedVolumeInMWh = tradingUnit === '%' ? unitConversions.convert(
                    unitConversions.percentageToUnit(parentLockedVolume, parentTotalVolume),
                    this.volumeUnit.volumeName,
                    'MWh',
                    !isPeak ? parentNumDays : parentNumBusinessDays, isPeak
                ) : unitConversions.convert(
                    parentLockedVolume,
                    this.contractTradingUnit.tradingName,
                    'MWh',
                    !isPeak ? parentNumDays : parentNumBusinessDays, isPeak
                );
                if (typeof trade.periodStartDate.getMonth !== 'function') {
                    trade.periodStartDate = tradeHelper.fixDateOffset(new Date(trade.periodStartDate));
                    trade.periodEndDate = tradeHelper.fixDateOffset(new Date(trade.periodEndDate));
                }

                var childNumOfDays = dates.getDateDiffInDays(trade.periodStartDate, trade.periodEndDate);
                var childNumOfBusinessDays = dates.getBusinessDatesCount(trade.periodStartDate, trade.periodEndDate);
                var childAvailableVolume = null;
                if ((trade.periodId && trade.periodId === 2) || trade.splitPeriodIntoId && trade.splitPeriodIntoId === 3) {
                    childAvailableVolume = volumes.filter(v => { return v.volumeId === trade.volumeId })[0];
                } else {
                    childAvailableVolume = this.getProductTotalVolumeByTradeablePeriodId(tradePeriods, volumes,trade.contractTradeablePeriodId);
                }

                var childAvailableVolumeInMWh = unitConversions.convert(
                    childAvailableVolume[this.selectedProductKey],
                    this.volumeUnit.volumeName,
                    'MWh',
                    !isPeak ? childNumOfDays : childNumOfBusinessDays, isPeak
                );

                if (childAvailableVolume[this.selectedProductKey] === 0) {

                    result = 0;
                } else if (['kWh', 'MWh', 'mmbtu', 'therm'].includes(tradingUnit)) {
                    result = (parentLockedVolume / parentNumDays) * childNumOfDays;

                } else if (tradingUnit === '%' && apportionmentId && apportionmentId === 1) { // apportioned by period
                    if (this.volumeUnit.volumeName != 'MW' && this.volumeUnit.volumeName != 'th/d') {
                        var parentTotalVol = this.getProductTotalVolumeByTradeablePeriodId(tradePeriods, volumes, this.data.contractTradeablePeriodId);
                        var parentCalculatedLockedVolMWh = unitConversions.convert(
                            unitConversions.percentageToUnit(parentLockedVolume, parentTotalVol),
                            this.volumeUnit.volumeName,
                            'MWh',
                            !isPeak ? parentNumDays : parentNumBusinessDays, isPeak
                        );
                        result = (((parentCalculatedLockedVolMWh / parentNumDays) * childNumOfDays) / childAvailableVolumeInMWh) * 100;
                    }
                    else {
                        result = parentLockedVolume;
                    }
                } else {
                    result = parentLockedVolume;

                }

                if (result != undefined) {
                    return result;
                }

                return result;
            },
            apportionAtgLockedVolume: function (tradePeriods,volumes,tradingUnit, trade, atgLockedVolume, contractId) {

                var result = null;
                var key = this.getSelectedProductKey();

                var atgTotalOpenVolume = this.getProductTotalVolumeByTradeablePeriodId(tradePeriods, volumes, trade.contractTradeablePeriodId, true);

                var contractOpenVolume = null;
                if ((trade.periodId && trade.periodId === 2) || trade.splitPeriodIntoId && trade.splitPeriodIntoId === 3) {
                    if (this.selectedTradePeriodIndicator === 'M') {
                        var volumeMatched = volumes.filter(v => { return v.volumeId === trade.volumeId })[0];
                        contractOpenVolume = volumeMatched[key + "Open"];
                    } else {
                        contractOpenVolume = this.getProductTotalVolumeByTradeablePeriodId(tradePeriods, volumes,trade.contractTradeablePeriodId, true, contractId);
                    }
                } else {
                    contractOpenVolume = this.getProductTotalVolumeByTradeablePeriodId(tradePeriods, volumes,trade.contractTradeablePeriodId, true, contractId);
                }
                if (tradingUnit !== '%') {
                    result = (atgLockedVolume * contractOpenVolume) / atgTotalOpenVolume;
                }
                else {
                    result = atgLockedVolume;
                }

                if (result != undefined) {
                    return result;
                }

                return result;
            },
            setCalculatedLockedVolume: function (selectedTradeablePeriodId, lockedVolume = null, parentLockedVolume = null) {
                if (lockedVolume != null) {
                    this.calculatedLockedVolume = this.calculateLockedVolume(null, null, null, null, lockedVolume, null, false, parentLockedVolume);
                   } else {
                    this.calculatedLockedVolume = this.calculateLockedVolume();
                }
                this.setTradedValue();
            },
            calculateTradedValue: function (price = null) {
                if (price === null) {
                    price = this.data.price;
                }

                let multiplier = price;

                // handle pence per therm to gbp
                if (this.priceUnit && !(this.priceUnit === '') && this.priceUnit.split("/")[0] === 'p') {
                    multiplier = multiplier / 100;
                }

                return this.calculatedLockedVolume * multiplier || 0;
            },
            setTradedValue: function () {
                this.tradedValue = this.calculateTradedValue();
            },
            /**
             * This method returns an array of volume (trade period) objects
             *
             * @param periodId - Selected tradeable period
             * @param contractId - Optional, required when working with ATGs
             */
            getMonthlyVolumesForTradeablePeriod: function (tradePeriods,volumes,periodId, contractId = null) {
                var self = this;
                let monthlyVolumes = tradeHelper.getTradeablePeriodMonthlyVolumes(tradePeriods, volumes, periodId, contractId);

                //02.02.2022 added by Haris this regulate price after new caluculation after entering new locked volume.
                //Price now remain as it is.Related with Bug 1004
                var values = self.$refs.grid.dataSource;
                for (var i = 0; i < monthlyVolumes.length; i++) {
                    if (monthlyVolumes.length === values.length) {
                        if (monthlyVolumes[i] !== values[i]) {
                            monthlyVolumes[i].price = values[i].price;

                        }
                    }
                }

                var groupedPeriods;
                let result = JSON.parse(JSON.stringify(monthlyVolumes));
                var groupBy = function (xs, key) {
                        return xs.reduce(function (rv, x) {
                            (rv[x[key]] = rv[x[key]] || []).push(x);
                            return rv;
                        }, {});
                    };
                groupedPeriods = groupBy(result, 'tradablePeriod');


                var returnList = [];

                for (var monthlyVolume of result) {
                    var isAddedAlready = returnList.filter(p => { return p.tradablePeriod === monthlyVolume.tradablePeriod });
                    if (!isAddedAlready || isAddedAlready.length==0) {
                        var lockedVolume = 0;
                        var calculatedLockedVolume = 0;
                        var tradedValue = 0;
                        var openVolume = 0;
                        var volume = 0;
                        var price = 0;
                        var key = this.getSelectedProductKey();

                        for (var i = 0; i < groupedPeriods[monthlyVolume.tradablePeriod].length; i++) {
                            lockedVolume = this.data.lockedVolume;
                            calculatedLockedVolume += groupedPeriods[monthlyVolume.tradablePeriod][i].calculatedLockedVolume;
                            tradedValue += parseFloat(groupedPeriods[monthlyVolume.tradablePeriod][i].tradedValue);
                            openVolume += groupedPeriods[monthlyVolume.tradablePeriod][i][key + "Open"];
                            volume += groupedPeriods[monthlyVolume.tradablePeriod][i][key];

                        }
                        monthlyVolume.clientId = this.data.clientId;
                        monthlyVolume.stateId = this.data.stateId;
                        monthlyVolume.utilityTypeId = this.data.utilityTypeId;
                        monthlyVolume.companyId = this.data.companyId;
                        monthlyVolume.tradingGroupId = this.data.tradingGroupId;
                        monthlyVolume.productId = this.data.productId;
                        monthlyVolume.tradePeriodId = monthlyVolume.periodId;
                        monthlyVolume.tradePeriodSpanId = monthlyVolume.periodSpanId;
                        monthlyVolume.tradeEntityType = this.data.tradeEntityType;
                        monthlyVolume.lockedVolume = lockedVolume;
                        monthlyVolume.calculatedLockedVolume = calculatedLockedVolume;
                        monthlyVolume.tradedValue = tradedValue;
                        monthlyVolume.tradedBy = this.data.tradedBy;
                        monthlyVolume.confirmationReference = this.data.confirmationReference;
                        monthlyVolume.tradeDate = tradeHelper.fixDateOffset(this.data.tradeDate);
                        monthlyVolume.supplementaryNote = this.data.supplementaryNote;
                        monthlyVolume.confirmationTradeUrl = this.confirmationTradeFileUrls && this.confirmationTradeFileUrls.length > 0 ? this.confirmationTradeFileUrls.join() : null;
                        monthlyVolume.currencyId = this.data.currencyId;
                        monthlyVolume.tradingUnitId = this.data.tradingUnitId;
                        monthlyVolume.volumeUnitId = this.data.volumeUnitId;
                        monthlyVolume[key + "Open"] = openVolume;
                        monthlyVolume[key] = volume;
                        monthlyVolume.price = monthlyVolume.price;

                        returnList.push(monthlyVolume);
                    }
                }

                return returnList;
            },
            getTotalVolumeForTradeablePeriod: function (periodId) {
                let totalVolume = 0.0;
                let monthlyVolumes = tradeHelper.getTradeablePeriodMonthlyVolumes(this.tradePeriods, this.volumes.result, periodId);

                let productId = this.$refs.dplProducts.ej2Instances.value || this.selectedProductId;
                let product = this.products.filter(p => { return p.id === productId })[0];
                let key = this.normaliseProductName(product.productName);

                for (var monthlyVolume of monthlyVolumes) {
                    totalVolume += monthlyVolume[key];
                }

                return totalVolume;
            },
            getTotalOpenVolumeForTradeablePeriod: function (periodId, tradePeriods, volumes) {
                let totalOpenVolume = 0.0;
                let monthlyVolumes = tradeHelper.getTradeablePeriodMonthlyVolumes(tradePeriods, volumes, periodId);

                let productId = this.$refs.dplProducts.ej2Instances.value || this.selectedProductId;
                let product = this.products.filter(p => { return p.id === productId })[0];
                let key = this.normaliseProductName(product.productName);

                for (var monthlyVolume of monthlyVolumes) {
                    totalOpenVolume += monthlyVolume[key+"Open"];
                }

                return totalOpenVolume;
            },
            normaliseProductName: function (productName) {
                let name = null;
                switch (productName.toLowerCase()) {
                    case 'baseload':
                        name = 'base';
                        break;
                    case 'peakload':
                        name = 'peak';
                        break;
                    case 'off-peak':
                        name = 'offPeak';
                        break;
                    case 'gas':
                        name = 'gas';
                        break;
                    default:
                        name = 'base';
                        break;
                }
                return name;
            },
            getSelectedProductKey: function () {
                let productId = this.$refs.dplProducts.ej2Instances.value || this.selectedProductId;
                let product = this.products.filter(p => { return p.id === productId })[0];

                return this.normaliseProductName(product.productName);

            },

            updateChildTradesGridValues: function (splitPeriodId, contractId = null) {
                if (!this.initialLoad) {
                    //let self = this;
                    this.$refs.dplSplitPeriodInto.ej2Instances.value = splitPeriodId;
                    this.data.splitPeriodIntoId = splitPeriodId;
                    // monthly periods are now tied directly to volumes
                    if (splitPeriodId && splitPeriodId === 3 || this.selectedSplitPeriodInto && this.selectedSplitPeriodInto === 3) {
                        //base: 10
                        //calculatedLockedVolume: "0.00"
                        //contractId: 254
                        //gas: 0
                        //indicator: "M"
                        //tradingUnitName: "MWh"
                        //name: "Jan-21"
                        //offPeak: 0
                        //peak: 0
                        //periodId: 2
                        //periodSpanId: 1
                        //priceUnit: "�/MWh"
                        //total: 10
                        //tradablePeriod: "Jan-21"
                        //tradeGroupId: null
                        //volumeId: 5933
                        //year: 2021
                        let productId = this.$refs.dplProducts.ej2Instances.value || this.selectedProductId || this.data.productId;
                        let product = this.products.filter(p => { return p.id === productId })[0];
                        let key = this.normaliseProductName(product.productName);

                        // set values per calculation but keep tradeid if we are in update mode,so that we can update complex periods
                        var newValues = this.getMonthlyVolumesForTradeablePeriod(this.tradePeriods, this.volumes.result, this.selectedTradeablePeriodId, contractId);
                        for (const value of newValues) {
                            value.periodName = value.tradablePeriod;
                            var arr = this.cgTrades.filter(cgt => { return cgt.periodName === value.periodName });
                            var tradeId = arr.length > 0 ? arr[0].tradeId : null;
                            if (tradeId) {
                                value.tradeId = tradeId;
                            }
                        }
                        this.cgTrades = newValues;
                        for (var i = 0; i < this.cgTrades.length; i++) {
                            let sDate = tradeHelper.fixDateOffset(tradeHelper.getStartDateByTradePeriodSpanIdAndYear(this.cgTrades[i].periodSpanId, this.cgTrades[i].year));
                            let eDate = tradeHelper.fixDateOffset(tradeHelper.getEndDateByTradePeriodSpanIdAndYear(this.cgTrades[i].periodSpanId, this.cgTrades[i].year));

                            this.cgTrades[i].periodStartDate = sDate;
                            this.cgTrades[i].periodEndDate = eDate;
                            this.cgTrades[i].calculatedLockedVolume = this.cgTrades[i][key] === 0 ? 0 : this.calculateLockedVolume(sDate, eDate, this.cgTrades[i][key], 0, null, this.cgTrades[i], true);
                            this.cgTrades[i].tradingUnitName = this.tradingUnitName;
                            this.cgTrades[i].priceUnit = this.priceUnit;

                            this.cgTrades[i].periodName = this.cgTrades[i].tradablePeriod;
                            this.cgTrades[i].volumeHedgedPercentage = parseFloat(this.newCalculatePercentage(this.cgTrades[i].calculatedLockedVolume, this.cgTrades[i][key], sDate, eDate));
                        }
                    } else { // the below never triggers as per current functionality as we only split by month!
                        //calculatedLockedVolume: "30.00"
                        //contractId: 254
                        //endDate: "2020-03-31T00:00:00"
                        //id: 2338
                        //indicator: "Q"
                        //tradingUnitName: "MWh"
                        //name: "Q1-20"
                        //periodId: 3
                        //periodSpanId: 13
                        //priceUnit: "�/MWh"
                        //startDate: "2020-01-01T00:00:00"
                        //year: 2020
                        this.setComplexTradePeriods(splitPeriodId);
                        for (var i = 0; i < this.cgTrades.length; i++) {
                            let sDate = new Date(this.cgTrades[i].startDate);
                            let eDate = new Date(this.cgTrades[i].endDate);

                            this.cgTrades[i].periodStartDate = sDate;
                            this.cgTrades[i].periodEndDate = eDate;
                            this.cgTrades[i].calculatedLockedVolume = this.calculateLockedVolume(sDate, eDate, this.getProductTotalVolumeByTradeablePeriodId(this.tradePeriods, this.volumes.result, this.cgTrades[i].id), 0, null, this.cgTrades[i], true);

                            this.cgTrades[i].periodName = this.cgTrades[i].name;
                            this.cgTrades[i].tradingUnitName = this.tradingUnitName;
                            this.cgTrades[i].priceUnit = this.priceUnit;

                            this.cgTrades[i].volumeHedgedPercentage = parseFloat(this.newCalculatePercentage(this.cgTrades[i].calculatedLockedVolume, this.getProductTotalVolumeByTradeablePeriodId(this.cgTrades[i].id), sDate, eDate));
                        }
                    }
                    this.selectedSplitPeriodInto = splitPeriodId;

                    //this.$refs.grid.data = this.cgTrades;
                    //this.$refs.grid.dataSource = this.cgTrades;

                    this.$refs.grid.refresh();
                  }
            },// the below never triggers as per current functionality as we only split by month!
            setComplexTradePeriods: function (splitPeriodId = null) {
                let selectedTradePeriod = this.tradePeriods.filter(tp => { return tp.id === this.selectedTradeablePeriodId })[0];

                if (selectedTradePeriod.indicator !== 'S') {
                    this.cgTrades = splitPeriodId ? this.tradePeriods.filter(tp => { return tp.year === this.selectedTradeablePeriodYear && tp.indicator === this.splitPeriodIntoBase.filter(spi => { return spi.id === splitPeriodId })[0].name }) :
                        this.tradePeriods.filter(tp => { return tp.year === this.selectedTradeablePeriodYear && tp.indicator === this.splitPeriodIntoBase.filter(spi => { return spi.id === this.selectedSplitPeriodInto })[0].name });
                } else {
                    if (selectedTradePeriod.name.startsWith("Sum")) {
                        this.cgTrades = this.tradePeriods.filter(tp => { return tp.year === this.selectedTradeablePeriodYear && (tp.name.startsWith("Q2") || tp.name.startsWith("Q3")) });
                    } else {
                        // Winter includes Q1 of the following year
                        this.cgTrades = this.tradePeriods.filter(tp => { return (tp.year === this.selectedTradeablePeriodYear && tp.name.startsWith("Q4")) || (tp.year === this.selectedTradeablePeriodYear + 1 && tp.name.startsWith("Q1")) });
                    }
                }
            },
            getProductTotalVolumeByTradeablePeriodId: function (tradePeriods, volumes, tradeablePeriodId, open = false, contractId = null) {

                //let self = this;
                let key = this.getSelectedProductKey();

                let volumeRecord = {
                    base: 0,
                    peak: 0,
                    offPeak: 0,
                    gas: 0,
                    total: 0,
                    baseOpen: 0,
                    peakOpen: 0,
                    offPeakOpen: 0,
                    gasOpen: 0,
                    totalOpen: 0
                };
                var weightedVolumeRecord = {
                    base: 0,
                    peak: 0,
                    offPeak: 0,
                    gas: 0,
                    total: 0,
                    baseOpen: 0,
                    peakOpen: 0,
                    offPeakOpen: 0,
                    gasOpen: 0,
                    totalOpen: 0
                };
                let volumesToSum = this.getMonthlyVolumesForTradeablePeriod(tradePeriods, this.volumes.result, tradeablePeriodId, contractId);

                for (var volumeToSum of volumesToSum) {
                    volumeRecord[key] += volumeToSum[key];
                    if (volumeToSum[key + "Open"]) {
                        volumeRecord[key + "Open"] += volumeToSum[key + "Open"];
                    }
                }

                for (var volumeToSum of volumesToSum) {
                    if (['MW', 'th/d'].includes(this.volumeUnit.volumeName)) {
                        weightedVolumeRecord[key] += (volumeToSum[key] * dates.getDateDiffInDays(new Date(volumeToSum.startDate), new Date(volumeToSum.endDate)));
                        if (volumeToSum[key + "Open"]) {
                            weightedVolumeRecord[key + "Open"] += (volumeToSum[key + "Open"] * dates.getDateDiffInDays(new Date(volumeToSum.startDate), new Date(volumeToSum.endDate)));
                        }
                    }
                }

                weightedVolumeRecord[key] = weightedVolumeRecord[key] / dates.getDateDiffInDays(this.data.periodStartDate, this.data.periodEndDate);
                if (weightedVolumeRecord[key + "Open"]) {
                    weightedVolumeRecord[key + "Open"] = weightedVolumeRecord[key + "Open"] / dates.getDateDiffInDays(this.data.periodStartDate, this.data.periodEndDate);
                };
                var returnValue = ['MW', 'th/d'].includes(this.volumeUnit.name) ? (open==true ? weightedVolumeRecord[key + "Open"] : weightedVolumeRecord[key]) : (open==true ? volumeRecord[key + "Open"] : volumeRecord[key]);
                return returnValue;
            },
            willBeOverHedged: function (tradePeriods, volumes, tradeablePeriodId, contractId, newVolume,existingTradesList,existingVolume,periodName,vlm) {

                //let self = this;
                let key = this.getSelectedProductKey();

                let volumeRecord = {
                    base: 0,
                    peak: 0,
                    offPeak: 0,
                    gas: 0,
                    total: 0,
                    baseOpen: 0,
                    peakOpen: 0,
                    offPeakOpen: 0,
                    gasOpen: 0,
                    totalOpen: 0
                };
                var weightedVolumeRecord = {
                    base: 0,
                    peak: 0,
                    offPeak: 0,
                    gas: 0,
                    total: 0,
                    baseOpen: 0,
                    peakOpen: 0,
                    offPeakOpen: 0,
                    gasOpen: 0,
                    totalOpen: 0
                };
                var currentOpenVolume = 0;
                let volumesToSum = [];
                let isPeak = this.$refs.dplProducts && this.products && this.products.filter(p => { return p.name === this.$refs.dplProducts.ej2Instances.text })[0] ?
                    this.products.filter(p => { return p.name === this.$refs.dplProducts.ej2Instances.text })[0].productName == "Peakload" : false;

                if (vlm) {

                    currentOpenVolume = vlm[key + "Open"];

                    let numDays = dates.getDateDiffInDays(vlm.startDate, vlm.endDate);
                    let numBusinessDays = dates.getBusinessDatesCount(vlm.startDate, vlm.endDate);

                    if (this.tradingUnitTradingName !== this.volumeUnit.volumeName) {
                        currentOpenVolume = unitConversions.convert(
                            currentOpenVolume,
                            this.volumeUnit.volumeName,
                            this.tradingUnitTradingName,
                            !isPeak ? numDays : numBusinessDays, isPeak
                        );
                    }
                }
                else {
                    volumesToSum = this.getMonthlyVolumesForTradeablePeriod(tradePeriods, this.volumes.result, tradeablePeriodId, contractId);

                    for (var volumeToSum of volumesToSum) {
                        volumeRecord[key] += volumeToSum[key];
                        if (volumeToSum[key + "Open"]) {
                            volumeRecord[key + "Open"] += volumeToSum[key + "Open"];
                        }
                    }

                    for (var volumeToSum of volumesToSum) {
                        if (['MW', 'th/d'].includes(this.volumeUnit.volumeName)) {
                            weightedVolumeRecord[key] += (volumeToSum[key] * dates.getDateDiffInDays(new Date(volumeToSum.startDate), new Date(volumeToSum.endDate)));
                            if (volumeToSum[key + "Open"]) {
                                weightedVolumeRecord[key + "Open"] += (volumeToSum[key + "Open"] * dates.getDateDiffInDays(new Date(volumeToSum.startDate), new Date(volumeToSum.endDate)));
                            }
                        }
                    }

                    weightedVolumeRecord[key] = weightedVolumeRecord[key] / dates.getDateDiffInDays(this.data.periodStartDate, this.data.periodEndDate);
                    if (weightedVolumeRecord[key + "Open"]) {
                        weightedVolumeRecord[key + "Open"] = weightedVolumeRecord[key + "Open"] / dates.getDateDiffInDays(this.data.periodStartDate, this.data.periodEndDate);
                    };

                    currentOpenVolume = ['MW', 'th/d'].includes(this.volumeUnit.name) ? weightedVolumeRecord[key + "Open"] : volumeRecord[key + "Open"];


                    let numDays = dates.getDateDiffInDays(this.data.periodStartDate, this.data.periodEndDate);
                    let numBusinessDays = dates.getBusinessDatesCount(this.data.periodStartDate, this.data.periodEndDate);

                    // do conversion of volume to the calculatedlocked unit that is reuters/market trading unit
                    if (this.tradingUnitTradingName !== this.volumeUnit.volumeName) {
                        currentOpenVolume = unitConversions.convert(
                            currentOpenVolume,
                            this.volumeUnit.volumeName,
                            this.tradingUnitTradingName,
                            !isPeak ? numDays : numBusinessDays, isPeak
                        );
                    }

                }
                // if it is an trade edit remove the already saved existing volume as we we are editing the volume/trade
                currentOpenVolume += existingVolume;
                // if it is an complex trade edit/or trade period, find and remove the already saved existing volume as we we are editing the volume/trade
                if (existingTradesList && existingTradesList.length > 0) {
                    var trade = existingTradesList.filter(tp => { return tp.periodName === periodName })[0];
                    currentOpenVolume += trade.calculatedLockedVolume;
                }
                parseFloat(currentOpenVolume.toFixed(4))
                return (parseFloat(currentOpenVolume.toFixed(4)) - parseFloat(newVolume.toFixed(4))  < 0);
            },
            calculateTradedVolume: function (tradePeriods, tradeablePeriodId, contractId = null) {

                //let self = this;
                this.splitPeriodInto = null;
                let tradablePeriod = tradePeriods.filter(tp => { return tp.id === tradeablePeriodId })[0];
                if (!tradablePeriod.startDate) {
                    tradablePeriod.startDate = tradeHelper.getStartDateByTradePeriodSpanIdAndYear(tradablePeriod.periodSpanId, tradablePeriod.year);
                }
                this.$refs.dplPeriodStartDate.ej2Instances.value = new Date(tradablePeriod.startDate);
                this.data.periodStartDate = new Date(tradablePeriod.startDate);
                if (!tradablePeriod.endDate) {
                    tradablePeriod.endDate = tradeHelper.getEndDateByTradePeriodSpanIdAndYear(tradablePeriod.periodSpanId, tradablePeriod.year);
                }
                this.$refs.dplPeriodEndDate.ej2Instances.value = new Date(tradablePeriod.endDate);
                this.data.periodEndDate = new Date(tradablePeriod.endDate);
                if (this.volumes == undefined) {
                    this.volumes = this.volumeData;
                }
                this.volumeInVolumeUnit = this.getProductTotalVolumeByTradeablePeriodId(tradePeriods, this.volumes.result, tradeablePeriodId, this.contractTradingUnit.tradingName === '%' ? false : !!contractId, contractId);

                let productName = this.products.filter(p => { return p.name === this.$refs.dplProducts.ej2Instances.text })[0].productName;
                let isPeak = productName == "Peakload";
                var childNumOfDays = dates.getDateDiffInDays(this.$refs.dplPeriodStartDate.ej2Instances.value, this.$refs.dplPeriodEndDate.ej2Instances.value);
                var childNumOfBusinessDays = dates.getBusinessDatesCount(this.$refs.dplPeriodStartDate.ej2Instances.value, this.$refs.dplPeriodEndDate.ej2Instances.value);
                // value is converted from contract volume unit to trading unit, unless the trading symbol is '%'
                if (this.contractTradingUnit.tradingName  !== '%') {
                    this.tradePeriodVolume = unitConversions.convert(
                        this.volumeInVolumeUnit,
                        this.volumeUnit.volumeName,
                        this.contractTradingUnit.tradingName,
                        !isPeak ? childNumOfDays : childNumOfBusinessDays, isPeak
                    );
                } else {
                    this.tradePeriodVolume = this.volumeInVolumeUnit;
                }

                // Since only selected tradeable periods are generated for a contract,
                // allow splitting periods only into the selected ones(the ones that are generated for that contract).
                let splitPeriods = null;
                if (tradePeriods.some(tp => tp.period)) {
                    splitPeriods = this.splitPeriodIntoBase.filter(spi => { return tradePeriods.some(tp => tp.period.indicator === spi.name) });
                    this.selectedTradePeriodIndicator = tradePeriods.filter(tp => { return tp.id === tradeablePeriodId })[0].period['indicator'];
                } else {
                    splitPeriods = this.splitPeriodIntoBase.filter(spi => { return tradePeriods.some(tp => tp.indicator === spi.name) });
                    this.selectedTradePeriodIndicator = tradePeriods.filter(tp => { return tp.id === tradeablePeriodId })[0]['indicator'];
                }

                if (this.selectedTradePeriodIndicator === 'Y') {
                    this.splitPeriodInto = splitPeriods;
                } else if (this.selectedTradePeriodIndicator === 'S' ) {
                    this.splitPeriodInto = splitPeriods.filter(sp => { return sp.name === 'M' || sp.name === 'Q' });
                } else if (this.selectedTradePeriodIndicator === 'Q') {
                    this.splitPeriodInto = splitPeriods.filter(sp => { return sp.name === 'M' });
                }

                if (this.selectedTradePeriodIndicator !== 'M' && this.splitPeriodInto && this.splitPeriodInto.length > 0) {
                    this.$refs.complexTradeEntityType.ej2Instances.disabled = false;
                } else {
                    this.$refs.complexTradeEntityType.ej2Instances.disabled = true;
                    this.$refs.simpleTradeEntityType.ej2Instances.checked = true;
                    this.tradeEntityTypeChanged(false);
                }

              },
            actionBegin: function (args) {
                if (args.requestType === 'beginEdit') {
                    selectedRecord = {};
                    selectedRecord = args.rowData;
                }
            },
            complexTradePriceUpdate: function (args) {
                selectedRecord['price'] = args.value;
                let gridObj = this.$refs.grid.ej2Instances;
                gridObj.aggregateModule.refresh(selectedRecord);
            },
            addHeaders: function (args) {
                args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
            },
            onUploadSuccess: function (args) {
                var response = JSON.parse(args.e.currentTarget.response);
                if (response.confirmationTradeUrl) {
                    this.confirmationTradeFileUrls.push(response.confirmationTradeUrl);
                    this.tradeFilesItmes = this.getTradeUrl(this.confirmationTradeFileUrls);
                    let message = { title: 'Success!', content: `Trade file ${args.file.id} upload successfully.`, cssClass: 'e-toast-success' };
                    this.$root.$emit('showToast', message);
                }
            },
            tradeEntityTypeChanged(showComplex) {
                this.showComplex = showComplex;
                var lockedVolumeInfo = document.getElementById("lockedVolume-info");
                var lockedVolumeComplexInfo = document.getElementById("lockedVolumeComplex-info");
                var priceInfo = document.getElementById("price-info");
                if (showComplex == true) {
                    this.tradeForms.rules.lockedVolumeComplex.required = true;
                    this.tradeForms.rules.lockedVolume.required = false;
                    this.tradeForms.rules.price.required = false;

                    if(lockedVolumeInfo != null){
                        lockedVolumeInfo.style = "display: none;";
                    }
                    if (priceInfo != null) {
                        priceInfo.style = "display: none;";
                    }
                } else {
                    if (lockedVolumeComplexInfo != null) {
                        lockedVolumeComplexInfo.style = "display: none;";
                    }
                    this.tradeForms.rules.lockedVolumeComplex.required = false;
                    this.tradeForms.rules.lockedVolume.required = true;
                    this.tradeForms.rules.price.required = true;
                }
            },
            tradeClientTradingGroupChanged(showClient) {
                this.clientsEnabled = showClient;
                this.tradingGroupsEnabled = !showClient;
                const arrayFields = ["clients", "tradingGroups"]
                setTimeout(function () {
                    arrayFields.forEach(function (item) {
                        let inputElement = document.getElementById(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.input-group');
                            if (parentDiv) {
                                if (item == "clients" && showClient) {
                                    parentDiv.classList.add('required-input');
                                    document.getElementById(item).ej2_instances[0].showPopup();
                                }
                                else if (item == "tradingGroups" && !showClient) {
                                    parentDiv.classList.add('required-input');
                                    document.getElementById(item).ej2_instances[0].showPopup();
                                }
                                else {
                                    parentDiv.classList.remove('required-input');
                                }
                            }
                        }
                    });
                }, 300);
            },
            onClientChange: function (e) {
                if (!this.$route.params.tradeId) {
                    this.$refs.dplStates.ej2Instances.value = null;
                    this.$refs.dplUtilities.ej2Instances.value = null;
                    this.$refs.dplCompanies.ej2Instances.value = null;
                    this.$refs.dplContracts.ej2Instances.value = null;
                    this.$refs.dplTradingGroups.ej2Instances.value = null;
                    this.utilitiesEnabled = false;
                    this.companiesEnabled = false;
                    this.contractsEnabled = false;
                    this.tradingGroupsEnabled = false;
                    this.resetTrade();
                    this.statesEnabled = true;
                    this.populateStates(e.itemData.id);
                    this.data.atgTradeId = null;
                }
                setTimeout(function () {
                    document.getElementById("states").ej2_instances[0].showPopup();
                }, 200);
            },
            onProductChange: function (e) {
                var self = this;
                this.contractsEnabled = false;
                this.tradingGroupsEnabled = false;
                if (!self.$route.params.tradeId) {
                    showSpinner(document.getElementById('mainSpinner'));
                    var selContractid = self.selectedContractId
                    if (!selContractid) {
                        selContractid = self.selectedTradingGroupContracts[0].contractId;
                    }

                    let prod = this.products.filter(p => { return p.id === e.itemData.id })[0];
                    this.selectedProductKey = this.normaliseProductName(prod.productName);

                    apis.protectedApi(`${urls.apiBaseUrl}Contract/AditionalTriggerData/${selContractid}`).then(resp => {

                        self.selectedTradingUnitId = resp.data.tradingUnitId;
                        self.tradingUnitName = resp.data.tradingUnitName;
                        self.tradingUnitTradingName = resp.data.tradingUnitName;
                        self.selectedCurrencyId = resp.data.currencyId;
                        self.priceUnit = resp.data.units;
                        self.tradeCurrency = resp.data.currencySymbol === 'p' ? JSON.parse(`["\\u${'00A3'}"]`)[0] : resp.data.currencySymbol;
                        self.perMonthDistribution = resp.data.perMonthDistribution;
                        hideSpinner(document.getElementById('mainSpinner'));

                        self.tradePeriodsEnabled = true;

                    }).catch(e => {
                        if (e.response) {
                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                            hideSpinner(document.getElementById('mainSpinner'));
                        }
                    })
                }
                setTimeout(function () {
                    if (document.getElementById("priceArea")) {
                        document.getElementById("priceArea").ej2_instances[0].showPopup();
                    } else {
                        document.getElementById("tradePeriods").ej2_instances[0].showPopup();
                    }
                }, 500);
            },
            onStateChange: function (e) {
                if (!this.$route.params.tradeId) {
                    this.showTradeSection = false;
                    this.$refs.dplUtilities.ej2Instances.value = null;
                    this.$refs.dplCompanies.ej2Instances.value = null;
                    this.$refs.dplContracts.ej2Instances.value = null;
                    this.$refs.dplTradingGroups.ej2Instances.value = null;

                    this.utilitiesEnabled = true;
                    this.companiesEnabled = false;
                    this.contractsEnabled = false;
                    this.tradingGroupsEnabled = false;

                    this.resetTrade();
                    var selectedClientId = this.$refs.dplClients.ej2Instances.value;
                    this.populateCompanies(selectedClientId, e.itemData.id);
                }
                setTimeout(function () {
                    document.getElementById("utilities").ej2_instances[0].showPopup();
                }, 200);

            },
            onUtilityChange: function (e) {
                if (!this.$route.params.tradeId) {
                    this.showTradeSection = false;
                    this.$refs.dplCompanies.ej2Instances.value = null;
                    this.$refs.dplContracts.ej2Instances.value = null;
                    this.$refs.dplTradingGroups.ej2Instances.value = null;

                    this.companiesEnabled = true;
                    this.contractsEnabled = false;
                    this.tradingGroupsEnabled = true;

                    this.resetTrade();
                    //this.populateTradingGroups(this.$refs.dplClients.ej2Instances.value, this.$refs.dplStates.ej2Instances.value, e.itemData.utilityTypeId);
                }
                setTimeout(function () {
                    document.getElementById("companies").ej2_instances[0].showPopup();
                }, 200);
            },
            onCompanyChange: function (e) {
                this.showTradeSection = false;
                this.$refs.dplContracts.ej2Instances.value = null;
                this.$refs.dplTradingGroups.ej2Instances.value = null;
                this.contractsEnabled = true;
                this.tradingGroupsEnabled = false;
                this.selectedCompanyId = e.itemData.id;
                this.populateContracts(e.itemData.id, this.selectedStateId, this.selectedUtilityTypeId);
                setTimeout(function () {
                    document.getElementById("contracts").ej2_instances[0].showPopup();
                }, 200);
            },
            onContractChange: function (e) {
                let self = this;
                if (e.itemData && e.itemData.id) {
                    this.populatePriceAreas(e.itemData.id, null);
                    apis.protectedApi(`utils/contractTradingUnit?contractId=${e.itemData.id}`).then(contractTradingUnitResponse => {
                        apis.protectedApi(`utils/contractVolumeUnit?contractId=${e.itemData.id}`).then(contractVolumeUnitResponse => {
                            self.contractTradingUnit = contractTradingUnitResponse.data;
                            self.selectedContractApportionmentId = self.contracts.filter(c => { return c.id === self.selectedContractId })[0].apportionment;

                            self.volumeUnit = contractVolumeUnitResponse.data;
                            self.selectedVolumeUnitId = contractVolumeUnitResponse.data.id;
                        });
                    }).catch(e => {
                        if (e.response) {
                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                        }
                    })
                }

                if (!this.$route.params.tradeId) {

                    this.$refs.dplContracts.ej2Instances.value = null;
                    this.$refs.dplTradingGroups.ej2Instances.value = null;
                    this.populateProducts(e.itemData.id, null);
                    this.populateTradePeriods(e.itemData.id);
                    this.populateVolumes(e.itemData.id);
                    this.tradingGroupsEnabled = false;
                    this.showTradeSection = true;
                    this.showTradeSubSection = false;
                }
                setTimeout(function () {
                    document.getElementById("products").ej2_instances[0].showPopup();
                }, 200);
            },
            onTradingGroupChange: function (e) {

                var self = this;

                self.$refs.dplCompanies.ej2Instances.value = null;
                self.$refs.dplContracts.ej2Instances.value = null;
                if (e.itemData != undefined) {
                    var atgId = e.itemData.id;
                } else {
                    atgId = e.id;
                }
                this.populatePriceAreas(null, atgId)
                this.selectedStateId = this.tradingGroups.filter(tg => tg.id === atgId)[0].stateId;
                this.selectedUtilityTypeId = this.tradingGroups.filter(tg => tg.id === atgId)[0].utilityTypeId;

                this.clientsEnabled = false;
                this.data.atgTradeId = uuidv4();

                apis.protectedApi(`utils/atgVolumesPeriods?atgId=${atgId}`).then(avpResponse => {
                    self.atgVolumesPeriodsPerContract = avpResponse.data.result;
                    apis.protectedApi(`tradinggroup/${atgId}`).then(response => {
                        self.selectedTradingGroupContracts = response.data.contracts;

                        apis.protectedApi(`utils/atgTradeablePeriods?atgId=${atgId}`).then(atgCtpResponse => {
                            self.atgTradePeriods = atgCtpResponse.data;

                            apis.protectedApi(`utils/contractTradingUnit?contractId=${self.selectedTradingGroupContracts[0].contractId}`).then(contractTradingUnitResponse => {
                                apis.protectedApi(`utils/tradingGroupVolumeUnit?tradingGroupId=${atgId}`).then(tradingGroupVolumeUnitResponse => {
                                    self.contractTradingUnit = contractTradingUnitResponse.data;

                                    self.populateProducts(self.selectedTradingGroupContracts[0].contractId, null);
                                    self.populateTradePeriods(self.selectedTradingGroupContracts[0].contractId);
                                    self.populateAtgVolumes(atgId);

                                    self.selectedContractApportionmentId = self.selectedTradingGroupContracts[0].tradeApportionmentId;

                                    self.companiesEnabled = false;
                                    self.contractsEnabled = false;
                                    self.showTradeSection = true;
                                    this.showTradeSubSection = false;

                                    self.volumeUnit = tradingGroupVolumeUnitResponse.data;
                                    self.selectedVolumeUnitId = tradingGroupVolumeUnitResponse.data.id;

                                });
                            });
                        });
                    });
                }).catch(e => {
                    if (e.response) {
                        this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                    }
                })
            },
            onSplitPeriodIntoChange: function (e) {
                this.selectedSplitPeriodInto = e.itemData.id;
                this.updateChildTradesGridValues(e.itemData.id);
            },
            onLockedVolumeChange: function (e) {
                this.data.lockedVolume = e.value;
                this.setCalculatedLockedVolume();
                if (this.splitPeriodInto && this.splitPeriodInto.length > 0) {
                    if (this.selectedSplitPeriodInto && this.splitPeriodInto.filter(spi => spi.id === this.selectedSplitPeriodInto).length > 0) {
                        this.updateChildTradesGridValues(this.selectedSplitPeriodInto);
                    } else {
                        this.updateChildTradesGridValues(this.splitPeriodInto[this.splitPeriodInto.length - 1].id);
                    }
                } else {
                    // contract has no monthly periods, but child tickets need to be generated for simple trades
                    // that have non-monthly trade period selected
                    this.updateChildTradesGridValues(3);
                }
            },
            onTradablePeriodChange: function (e) {
                this.processTradablePeriodChange(e.itemData.id);
            },
            processTradablePeriodChange(id, contractId = null) {
                var ctp = this.tradePeriods.filter(tp => { return tp.id === id })[0];
                this.selectedTradeablePeriodId = ctp.id;
                this.selectedTradeablePeriodYear = ctp.year;
                this.selectedTradeablePeriodPeriodId = ctp.periodId;
                this.selectedTradeablePeriodPeriodSpanId = ctp.periodSpanId;

                this.calculateTradedVolume(this.tradePeriods,id, contractId);
                if (this.$refs.complexTradeEntityType.ej2Instances.disabled === false) {
                    // calculateTradedVolume will have filtered out the incompatible trade periods
                    // so it is safe to take the first element.
                    this.updateChildTradesGridValues(this.splitPeriodInto[this.splitPeriodInto.length - 1].id, contractId);

                }
                var message = "";
                if (this.selectedTradingGroupContracts && this.selectedTradingGroupContracts.length > 0 && contractId == null) {

                    for (var i = 0; i < this.selectedTradingGroupContracts.length; i++) {

                        var vols = this.atgVolumesPeriodsPerContract.map(cvp => { return cvp.volumes });
                        var allVols = Array.prototype.concat.apply([], vols);

                        var ctps = this.atgVolumesPeriodsPerContract.map(cvp => { return cvp.contractTradeablePeriods });
                        var allCtps = null;
                        if (ctps.length > 0) {
                            allCtps = ctps[0];
                        }
                        if (ctps.length > 1) {
                            for (var j = 0; j < ctps.length - 1; j++) {
                                allCtps = allCtps.concat(ctps[j + 1]);
                            }
                        }

                        var tempCTP = allCtps.filter(ctp => {
                            return this.selectedTradeablePeriodPeriodSpanId > 0 ? ctp.contractId === this.selectedTradingGroupContracts[i].contractId &&
                                ctp.periodId === this.selectedTradeablePeriodPeriodId &&
                                ctp.periodSpanId === this.selectedTradeablePeriodPeriodSpanId &&
                                ctp.year === this.selectedTradeablePeriodYear :
                                ctp.contractId === this.selectedTradingGroupContracts[i].contractId &&
                                ctp.periodId === this.selectedTradeablePeriodPeriodId &&
                                ctp.year === this.selectedTradeablePeriodYear
                        })[0];
                        var vlms = allVols.filter(v => {
                            return  v.contractId === this.selectedTradingGroupContracts[i].contractId
                        });
                        var contCtps = allCtps.filter(v => {
                            return v.contractId === this.selectedTradingGroupContracts[i].contractId
                        });
                        var openVolume = this.getTotalOpenVolumeForTradeablePeriod(tempCTP.id, contCtps, vlms);

                        if (openVolume <= 0) {
                            message = message + "<br\> Contract: " + this.selectedTradingGroupContracts[i].contractName + " has no volumes for the selected period. ";
                        }

                    }
                }
                if (message != "") {
                    this.showErrorDialog(RMErrorType.noVolumesForSelectedPeriod, message);
                }
                else if (this.volumeInVolumeUnit > 0) {
                    this.showTradeSubSection = true;
                } else {
                    this.showErrorDialog(RMErrorType.noVolumesForSelectedPeriod, "Contract has no volumes for the selected period.");
                }
                //= new Date(tradablePeriod.startDate);
                //this.$refs.dplPeriodEndDate.ej2Instances.value = new Date(tradablePeriod.endDate);
                this.setCalculatedLockedVolume(this.selectedTradeablePeriodId);
             },
            resetTrade: function () {
                if (this.$refs.dplProducts) {
                    this.$refs.dplProducts.ej2Instances.value = null;
                }
                if (this.$refs.dplTradePeriods) {
                    this.$refs.dplTradePeriods.ej2Instances.value = null;
                }

                this.showTradeSection = false;
                this.showTradeSubSection = false;
            },
            resetTradeFull: function () {
                if (this.$refs.dplUtilities) {
                    this.$refs.dplUtilities.ej2Instances.value = null;
                }
                if (this.$refs.dplCompanies) {
                    this.$refs.dplCompanies.ej2Instances.value = null;
                }
                if (this.$refs.dplContracts) {
                    this.$refs.dplContracts.ej2Instances.value = null;
                }
                if (this.$refs.dplTradingGroups) {
                    this.$refs.dplTradingGroups.ej2Instances.value = null;
                }
                if (this.$refs.dplProducts) {
                    this.$refs.dplProducts.ej2Instances.value = null;
                }
                if (this.$refs.dplTradePeriods) {
                    this.$refs.dplTradePeriods.ej2Instances.value = null;
                }

                this.showTradeSection = false;
                this.showTradeSubSection = false;
            },
            resetTradeablePeriod: function () {
                if (this.$refs.dplTradePeriods) {
                    this.$refs.dplTradePeriods.ej2Instances.value = null;
                }
                this.selectedTradeablePeriodId = null;
                this.showTradeSubSection = false;
            },
            populateClients: function (clientId) {

                    let url = `utils/parentclients?userId=${this.$store.state.loggedInUserId}&clientId=${clientId}`;
                    apis.protectedApi(url)
                        .then(response => {
                            this.clients = response.data;
                            setTimeout(() => {
                                this.selectedClientId = this.data.clientId;
                            }, 1000)
                        }).catch(e => {
                            if (e.response.data.message) {
                                this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                            }
                        });


            },
            populateStates: function (clientId) {
                //let self = this;
                let url = `utils/clientStates?clientId=${clientId}`;
                apis.protectedApi(url)
                    .then(response => {
                        this.states = response.data;
                        setTimeout(() => {
                            this.selectedStateId = this.data.stateId;
                        }, 1000)
                    }).catch(e => {
                        if (e.response.data.message) {
                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                        }
                    });
            },
            populateCompanies: function (clientId, stateId) {
                let url = `utils/clientCompanies?clientId=${clientId}&stateId=${stateId}&companyId=${this.data.companyId}`;
                apis.protectedApi(url)
                    .then(response => {
                        this.companies = response.data;
                        setTimeout(() => {
                            this.selectedCompanyId = this.data.companyId;
                        }, 1000)

                    }).catch(e => {
                        if (e.response.data.message) {
                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                        }
                    });
            },
            populateUtilities: function () {
                apis.protectedApi('utils/utilities')
                    .then(response => {
                        this.utilities = response.data;
                        setTimeout(() => {
                            this.selectedUtilityTypeId = this.data.utilityTypeId;
                        }, 1000)

                    }).catch(e => {
                        if (e.response.data.message) {
                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                        }
                    });
            },
            populateContracts: function (companyId, stateId, utilityTypeId) {
                let url = `utils/companyContracts?companyId=${companyId}&stateId=${stateId}&utilityTypeId=${utilityTypeId}&nonAtg=${true}`;
                apis.protectedApi(url)
                    .then(response => {
                        if (response && response.data && response.data.length > 0) {
                            this.contracts = response.data;
                            this.contractEnabled = true;
                            setTimeout(() => {
                                this.selectedContractId = this.data.contractId;
                            }, 1000)

                        } else {
                            this.contracts = [];
                            this.contractEnabled = false;
                            this.resetTrade();
                            this.showErrorDialog(RMErrorType.default, "No contracts exist for the selected criteria.");
                        }
                    }).catch(e => {
                        if (e.response.data.message) {
                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                        }
                    });
            },
            populateAtgContract: function (contractId, contractName) {

                this.contracts = [];
                this.contracts.push({ name: contractName, id: contractId });
                this.selectedContractId = contractId;

            },
            populateTradingGroups: function () {
                let url = `utils/tradingGroups`;
                apis.protectedApi(url)
                    .then(response => {
                        this.tradingGroups = response.data;
                        setTimeout(() => {
                            this.selectedTradingGroupId = this.data.tradingGroupId;
                        }, 1000)
                        var countries = response.data.map(item => { return { id: item.stateId, name: item.stateName } });
                        var unique = [];
                        var distinct = [];
                        for (let i = 0; i < countries.length; i++) {
                            if (!unique[countries[i].id]) {
                                distinct.push(countries[i]);
                                unique[countries[i].id] = 1;
                            }
                        }
                        this.states = distinct;
                    }).catch(e => {
                        if (e.response.data.message) {
                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                        }
                    });
            },
            populateProducts: function (contractId, utilityTypeId) {
                let url = `utils/products?contractId=${contractId}&utilityTypeId=${utilityTypeId}`;
                apis.protectedApi(url)
                    .then(response => {
                        this.products = response.data;
                        setTimeout(() => {
                            this.selectedProductId = this.data.productId;
                        }, 50)

                    }).catch(e => {
                        if (e.response.data.message) {
                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                        }
                    });
            },
            populateTradePeriods: function (contractId) {
                let self = this;
                let url = 'utils/contractTradeablePeriods';
                if (contractId) {
                    url += `?contractId=${contractId}`
                }
                apis.protectedApi(url)
                    .then(response => {
                        this.tradePeriods = response.data;
                        setTimeout(() => {
                            this.selectedTradeablePeriodId = self.data.tradeablePeriodId;
                        }, 1000)

                        if (this.selectedTradeablePeriodId) {
                            this.selectedTradePeriodIndicator = this.tradePeriods.filter(tp => { return tp.id === this.data.tradeablePeriodId })[0]['indicator'];
                        }
                    }).catch(e => {
                        if (e.response.data.message) {
                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                        }
                    });
            },
            populateTradePeriodSpans: function () {
                //let self = this;
                let url = 'utils/periodSpans';
                apis.protectedApi(url)
                    .then(response => {
                            this.tradePeriodSpans = response.data;

                    }).catch(e => {
                        if (e.response.data.message) {
                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                        }
                    });
            },

            populateVolumes: function (contractId) {
                let url = null;
                if (contractId) {
                    url = `volume/Contract/${contractId}/Open`;
                }
                // no need to ping trading group volumes as the volumes are universal on a trade group level, so we can just get it for the first contract
                //else if (tradingGroupId) {
                //    url = `volume/TradeGroup/${tradingGroupId}`;
                //}
                else {
                    this.showErrorDialog(RMErrorType.default, 'Please select either a contract or a trading group.');
                    return;
                }
                apis.protectedApi(url)
                    .then(response => {
                        this.volumes = response.data;
                    }).catch(e => {
                        if (e.response.data.message) {
                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                        }
                    });
            },
            populateAtgVolumes: function (atgId) {
                apis.protectedApi(`volume/TradingGroup/${atgId}/Open`)
                    .then(response => {
                        this.volumes = response.data;
                    }).catch(e => {
                        if (e.response.data.message) {
                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                        }
                    });
            },
            populatePriceAreas: function (contractId, atgId) {
                apis.protectedApi(`utils/pricingContractAreas?contractId=${contractId}&tradingGroupId=${atgId}`)
                    .then(response => {
                        this.priceAreas = response.data;
                        if (this.priceAreas.length > 0) {

                            this.showPriceAreaSection = true;
                            this.showPriceAreaTradePeriodSection = false,
                            this.showFormTradePeriodSection = true,
                            this.tradeForms.rules.priceArea.required = true;
                        }
                        else {

                            this.showPriceAreaSection = false;
                            this.showPriceAreaTradePeriodSection = true,
                            this.showFormTradePeriodSection = false,
                            this.tradeForms.rules.priceArea.required = false;

                        }
                    }).catch(e => {
                        if (e.response)
                            this.showErrorDialog(e.response.data.message);
                    });
            },
            getStandardTradeValuesFromGrid: function (contractId = null) {
                let standardTrades = [];
                if (contractId === null) {
                    contractId = this.selectedContractId;
                }

                let values = this.$refs.grid.dataSource;
                for (const value of values) {

                    var arr = this.cgTrades.filter(cgt => { return cgt.periodName === value.periodName });
                    var volumeId = arr.length > 0 ? arr[0].volumeId : null;
                    standardTrades.push({
                        clientId: this.data.clientId,
                        stateId: this.selectedStateId,
                        utilityTypeId: this.data.utilityTypeId,
                        companyId: this.data.companyId,
                        contractId: contractId,
                        tradingGroupId: this.data.tradingGroupId,
                        productId: this.data.productId,
                        tradePeriodId: value.periodId,
                        tradePeriodSpanId: value.periodSpanId,
                        tradingUnitId: this.data.tradingUnitId,
                        volumeUnitId: this.data.volumeUnitId,
                        currencyId: this.data.currencyId,
                        periodStartDate: tradeHelper.fixDateOffset(this.data.periodStartDate),
                        periodEndDate: tradeHelper.fixDateOffset(this.data.periodEndDate),
                        tradeEntityType: this.data.tradeEntityType ? 1 : 0,
                        lockedVolume: this.data.lockedVolume,
                        price: this.data.price,
                        // TODO: handle apportionment
                        calculatedLockedVolume: parseFloat(value.calculatedLockedVolume),
                        tradedValue: parseFloat(value.calculatedLockedVolume * this.data.price),
                        tradedBy: this.data.tradedBy,
                        confirmationReference: this.data.confirmationReference,
                        tradeDate: tradeHelper.fixDateOffset(this.data.tradeDate),
                        supplementaryNote: this.data.supplementaryNote,
                        confirmationTradeUrl: this.confirmationTradeFileUrls && this.confirmationTradeFileUrls.length > 0 ? this.confirmationTradeFileUrls.join() : null,
                        splitPeriodIntoId: this.data.splitPeriodIntoId,
                        complexGroupId: this.data.complexGroupId,
                        currencySymbol: this.data.currencySymbol,
                        tradingUnit: this.data.tradingUnit,
                        groupId: this.data.groupId,
                        isGroupParent: false,
                        volumeId: volumeId,
                        volumeHedgedPercentage: parseFloat(value.volumeHedgedPercentage),
                        atgTradeId: this.data.atgTradeId,
                        year: value.year,
                        IsComplexGroupParent: false
                    });
                }

                return standardTrades;
            },
            // Sending contractId to the function to be able to use it outside of the trading group loops
            getComplexTradeValuesFromGrid: function (contractId = null, lockedVolume = null,contractApportionment = null) {
                let self = this;
                let complexTrades = [];
                if (contractId === null) {
                    contractId = this.selectedContractId;
                }
                if (lockedVolume === null) {
                    lockedVolume = this.data.lockedVolume;
                }

                self.$refs.grid.refresh();
                var values = self.$refs.grid.dataSource;
                for (const value of values) {
                    var arr = this.cgTrades.filter(cgt => { return cgt.periodName === value.periodName });
                    var volumeId = arr.length > 0 ? arr[0].volumeId : null;
                    var apportionedLockedVolume = this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, value, lockedVolume, this.data.periodStartDate, this.data.periodEndDate,contractApportionment);
                    var compTrade = {
                        contractTradeablePeriodId: value.contractTradeablePeriodId ? value.contractTradeablePeriodId : value.id,
                        clientId: this.data.clientId,
                        stateId: this.selectedStateId,
                        utilityTypeId: this.data.utilityTypeId,
                        companyId: this.data.companyId,
                        contractId: contractId,
                        tradingGroupId: this.data.tradingGroupId,
                        productId: this.data.productId,
                        tradePeriodId: value.periodId,
                        tradePeriodSpanId: value.periodSpanId,
                        tradingUnitId: this.data.tradingUnitId,
                        volumeUnitId: this.data.volumeUnitId,
                        currencyId: this.data.currencyId,
                        periodStartDate: tradeHelper.fixDateOffset(value.periodStartDate),
                        periodEndDate: tradeHelper.fixDateOffset(value.periodEndDate),
                        tradeEntityType: this.data.tradeEntityType ? 1 : 0,
                        lockedVolume: apportionedLockedVolume === 0 ? 0 :apportionedLockedVolume,
                        price: value.price,
                        calculatedLockedVolume: parseFloat(value.calculatedLockedVolume),
                        tradedValue: parseFloat(value.calculatedLockedVolume * value.price),
                        tradedBy: this.data.tradedBy,
                        confirmationReference: this.data.confirmationReference,
                        tradeDate: tradeHelper.fixDateOffset(this.data.tradeDate),
                        supplementaryNote: this.data.supplementaryNote,
                        confirmationTradeUrl: this.confirmationTradeFileUrls && this.confirmationTradeFileUrls.length > 0 ? this.confirmationTradeFileUrls.join() : null,
                        splitPeriodIntoId: this.data.splitPeriodIntoId,
                        complexGroupId: this.data.complexGroupId,
                        currencySymbol: this.data.currencySymbol,
                        tradingUnit: this.data.tradingUnit,
                        groupId: null,
                        isGroupParent: false,
                        volumeId: volumeId,
                        volumeHedgedPercentage: value.volumeHedgedPercentage,
                        atgTradeId: this.data.atgTradeId,
                        IsComplexGroupParent: false,
                        tradeId: value.tradeId,
                        periodName:value.periodName
                    }

                    if (this.atgTradePeriods && this.atgTradePeriods.length > 0) {
                        compTrade.contractTradeablePeriodId = this.atgTradePeriods.filter(atp => {
                            return atp.contractId == compTrade.contractId &&
                                atp.periodSpanId == (this.tradePeriods.filter(tp => { return tp.id == compTrade.contractTradeablePeriodId })[0].periodSpanId) &&
                                atp.year == compTrade.periodStartDate.getFullYear() //start date year of any period is correct, even for winter (as was the issue for next year months,adn then wrong months from previous year were taken)

                        })[0].id;
                    }

                    complexTrades.push(compTrade);
                }

                return complexTrades;
            },
            checkVolumePeriods: async function (data) {

                try {
                    //Edina: 18/09/2024 - previousley added because of complex trade edit now not needed
                    //if (data.price == null || data.price == undefined) {
                    //    //price is not used for checking volumes but its needed for view model on services
                    //    data.price = 0;
                    //}
                    const response = await apis.protectedApi.post(`trade/checkVolumePeriod`, data, { isDateFix: true });
                    return response.data;

                } catch (e) {
                    if (e.response) {
                        this.showErrorDialog(RMErrorType.default, e.response.data.errors != null ? e.response.data.title : "Error invoking service, please contact support");
                        hideSpinner(document.getElementById('mainSpinner'));
                    }
                    return null;
                }
            },
            btnSaveClickTrade: async function (e) {
                e.preventDefault();
                if (this.isSubmitting) return;

                this.isSubmitting = true;
                //showSpinner(document.getElementById('mainSpinner'));
                //Added by Haris 02.02.2022 this check price for complex trade
                if (this.showComplex) {
                    let values = this.$refs.grid.dataSource;
                    for (var i = 0; i < values.length; i++) {
                        if (values[i].price == undefined) {
                            gridOptions.errorAlert("Price is missing for" + " " + values[i].periodName);
                            this.isSubmitting = false;
                            hideSpinner(document.getElementById('mainSpinner'));
                            return;
                        }

                    }
                }
                this.data.contractTradeablePeriodId = this.selectedTradeablePeriodId;
                this.data.productId = this.$refs.dplProducts.ej2Instances.value || this.selectedProductId;
                this.data.contractId = this.selectedContractId;
                if (this.data.contractTradeablePeriodId != null && this.data.productId != null) {
                    const checkData = await this.checkVolumePeriods(this.data);
                    if (checkData != null && checkData.checkPeriod) {
                        this.isSubmitting = false;
                        hideSpinner(document.getElementById('mainSpinner'));
                        this.showErrorDialog(RMErrorType.default, checkData.finalMessage)
                        return;
                    }
                }

                if (this.isHypothetical == false && this.tradeFilesItmes.length < 1) {
                    this.isSubmitting = false;
                    hideSpinner(document.getElementById('mainSpinner'));
                    this.showErrorDialog(RMErrorType.default, "Please upload confirmation trade file.")
                    return;
                }
                if ('priceArea' in this.tradeForms.rules && !this.showPriceAreaSection) {
                    delete this.tradeForms.rules.priceArea;
                    this.data.priceArea;
                }


                let formStatus = this.tradeForms.validate();
                if (formStatus) {
                    this.data.contractTradeablePeriodId = this.selectedTradeablePeriodId;
                    this.data.volumeHedgedPercentage = parseFloat(this.newCalculatePercentage(this.calculatedLockedVolume, this.getProductTotalVolumeByTradeablePeriodId(this.tradePeriods, this.volumes.result, this.selectedTradeablePeriodId), this.data.periodStartDate, this.data.periodEndDate));
                    let productId = this.$refs.dplProducts.ej2Instances.value || this.selectedProductId;
                    let product = this.products.filter(p => { return p.id === productId })[0];
                    let key = this.normaliseProductName(product.productName);

                    if (!this.isTradeablePeriodValid()) {
                        this.showErrorDialog(RMErrorType.tradePeriodPassed, "Trade date must be before the end date of the selected tradeable period. Please adjust the dates accordingly.");
                        this.isSubmitting = false;
                        return;
                    }
                    var isOverhedged = false;
                    var overhedgedPeriodsText = "This trade would exceed the available volume for the following period(s):";
                    //atg
                    if (this.selectedTradingGroupContracts && this.selectedTradingGroupContracts.length > 0) {
                        //get all contract tradeable period ids for atg- to be used while processing individual contracts

                        var vols = this.atgVolumesPeriodsPerContract.map(cvp => { return cvp.volumes });
                        var allVols = Array.prototype.concat.apply([], vols);

                        this.volumes = { result: allVols };

                        var ctps = this.atgVolumesPeriodsPerContract.map(cvp => { return cvp.contractTradeablePeriods });
                        var allCtps = null;
                        if (ctps.length > 0) {
                            allCtps = ctps[0];
                        }
                        if (ctps.length > 1) {
                            for (var j = 0; j < ctps.length - 1; j++) {
                                allCtps = allCtps.concat(ctps[j + 1]);
                            }
                        }

                        this.tradePeriods = allCtps;
                        // loop all contracts of atg
                        for (var i = 0; i < this.selectedTradingGroupContracts.length; i++) {
                            // match the tradeable period id with the contract and tradeable period selected
                            var tempCTP = allCtps.filter(ctp => {
                                return this.selectedTradeablePeriodPeriodSpanId > 0 ? ctp.contractId === this.selectedTradingGroupContracts[i].contractId &&
                                    ctp.periodId === this.selectedTradeablePeriodPeriodId &&
                                    ctp.periodSpanId === this.selectedTradeablePeriodPeriodSpanId &&
                                    ctp.year === this.selectedTradeablePeriodYear :
                                    ctp.contractId === this.selectedTradingGroupContracts[i].contractId &&
                                    ctp.periodId === this.selectedTradeablePeriodPeriodId &&
                                    ctp.year === this.selectedTradeablePeriodYear
                            })[0];
                            this.calculateTradedVolume(this.tradePeriods, tempCTP.id, this.selectedTradingGroupContracts[i].contractId);

                            var atgTotalLockedVolume = JSON.parse(JSON.stringify(this.data.lockedVolume));
                            //Haris test babel problem
                            var selectedPeriod = this.tradePeriods.filter(tp => { return tp.id === tempCTP.id })[0];
                            var vlms = this.volumes.result.filter(v => { return v.tradablePeriod === selectedPeriod.name && v.year === this.selectedTradeablePeriodYear && v.contractId == tempCTP.contractId });
                            this.data.volumeId = selectedPeriod.periodId === 2 && vlms.length > 0 ? vlms[0].volumeId : null;

                            var atgContractLockedVolume = this.apportionAtgLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, this.data, atgTotalLockedVolume, this.selectedTradingGroupContracts[i].contractId);
                            if (!this.showComplex) {// standard trade is selected
                                var dataCalculatedLockedVolume = this.calculateLockedVolume(null, null, null, null, atgContractLockedVolume, null, false, atgTotalLockedVolume);
                                isOverhedged = this.willBeOverHedged(this.tradePeriods, this.volumes.result, tempCTP.id, this.selectedTradingGroupContracts[i].contractId, dataCalculatedLockedVolume, null, this.existingCalculatedLockedVolume, null);
                                if (isOverhedged) {
                                    overhedgedPeriodsText = overhedgedPeriodsText + "<br\> Contract name:" + this.selectedTradingGroupContracts[i].contractName + " id: " + this.selectedTradingGroupContracts[i].contractId + "for the period chosen:" + selectedPeriod.name + ","
                                }

                            }
                            else {

                                let trades = this.getComplexTradeValuesFromGrid(this.selectedTradingGroupContracts[i].contractId, atgContractLockedVolume);
                                this.setCalculatedLockedVolume(tempCTP.id, atgContractLockedVolume, atgTotalLockedVolume);
                                this.data.calculatedLockedVolume = parseFloat(this.calculatedLockedVolume);

                                for (var trd of trades) {
                                    var volume = this.volumes.result.filter(v => v.volumeId === trd.volumeId)[0];
                                    trd.calculatedLockedVolume = volume === 0 ? 0 : parseFloat(this.calculateLockedVolume(trd.periodStartDate, trd.periodEndDate, volume[key], volume[key], trd.lockedVolume, trd, (this.contractTradingUnit.tradingName === '%' && this.selectedContractApportionmentId && this.selectedContractApportionmentId === 1) ? true : false, this.data.lockedVolume));
                                }

                                for (var trd of trades) {
                                    var volume = this.volumes.result.filter(v => v.volumeId === trd.volumeId)[0];
                                    var calculatedLockedVolume = volume === 0 ? 0 : parseFloat(this.calculateLockedVolume(trd.periodStartDate, trd.periodEndDate, volume[key], volume[key], trd.lockedVolume, trd, false, atgContractLockedVolume));

                                    var overhedged = this.willBeOverHedged(this.tradePeriods, this.volumes.result, trd.contractTradeablePeriodId, this.selectedTradingGroupContracts[i].contractId, trd.calculatedLockedVolume, this.existingCgTrades, 0, trd.periodName)
                                    if (overhedged) {
                                        isOverhedged = true;
                                        overhedgedPeriodsText = overhedgedPeriodsText + "<br\> Contract name:" + this.selectedTradingGroupContracts[i].contractName + " id: " + this.selectedTradingGroupContracts[i].contractId + " period:" + trd.periodName + ","
                                    }
                                }
                            }
                        }
                    }
                    else {
                        //contract trade
                        if (!this.showComplex) {
                            //normal trade
                            //parent check
                            let selectedPeriod = this.tradePeriods.filter(tp => { return tp.id === this.selectedTradeablePeriodId })[0];
                            isOverhedged = this.willBeOverHedged(this.tradePeriods, this.volumes.result, this.data.contractTradeablePeriodId, this.data.contractId, parseFloat(this.calculatedLockedVolume), null, this.existingCalculatedLockedVolume, null)
                            if (isOverhedged) {
                                overhedgedPeriodsText = overhedgedPeriodsText + " for period chosen:" + selectedPeriod.name + ","
                            }
                            if (selectedPeriod.indicator !== 'M') {
                                // child check
                                var trades = this.getStandardTradeValuesFromGrid();
                                for (var trade of trades) {
                                    var vlm = this.volumes.result.filter(v => {
                                        return v.periodSpanId === trade.tradePeriodSpanId && v.year === trade.year;
                                    })[0];
                                    trade.periodStartDate = tradeHelper.fixDateOffset(tradeHelper.getStartDateByTradePeriodSpanIdAndYear(vlm.periodSpanId, vlm.year));
                                    trade.periodEndDate = tradeHelper.fixDateOffset(tradeHelper.getEndDateByTradePeriodSpanIdAndYear(vlm.periodSpanId, vlm.year));

                                    var lockedVolume = this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, trade, this.data.lockedVolume, this.data.periodStartDate, this.data.periodEndDate, this.selectedContractApportionmentId);
                                    var calculatedLockedVolume = this.calculateLockedVolume(trade.periodStartDate, trade.periodEndDate, vlm[key], 0, lockedVolume, trade, true);
                                    var isSubPeriodOverhedged = this.willBeOverHedged(this.tradePeriods, this.volumes.result, this.data.contractTradeablePeriodId, this.data.contractId, calculatedLockedVolume, null, this.existingCalculatedLockedVolume, null, vlm)
                                    if (isSubPeriodOverhedged) {
                                        isOverhedged = true;
                                        overhedgedPeriodsText = overhedgedPeriodsText + "<br\> period:" + vlm.tradablePeriod + ","
                                    }
                                }
                            }
                        }
                        else {
                            //complex contract trade
                            let tradess = this.getComplexTradeValuesFromGrid(this.selectedContractId, null, this.selectedContractApportionmentId);


                            for (var trd of tradess) {
                                var isSubPeriodOverhedged = this.willBeOverHedged(this.tradePeriods, this.volumes.result, trd.contractTradeablePeriodId, this.selectedContractId, trd.calculatedLockedVolume, this.existingCgTrades, 0, trd.periodName)
                                if (isSubPeriodOverhedged) {
                                    isOverhedged = true;
                                    overhedgedPeriodsText = overhedgedPeriodsText + "<br\> period:" + trd.periodName + ","
                                }
                            }
                        }
                    }
                    if (isOverhedged) {
                        this.showOverHedgeWarningDialog(overhedgedPeriodsText);
                    } else {
                        this.completeSave();
                    }
                }
                else {
                    this.isSubmitting = false;
                }
            },
            completeSave: function () {
                showSpinner(document.getElementById('mainSpinner'));
                var self = this;
                if (AlertDialog) {
                    AlertDialog.hide();
                }
                this.canSave = false;
                this.data.clientId = this.selectedClientId;
                this.data.stateId = this.selectedStateId;
                this.data.utilityTypeId = this.selectedUtilityTypeId;
                this.data.companyId = this.selectedCompanyId;
                if (this.selectedContractId) {
                    this.data.contractId = this.selectedContractId;
                }
                this.data.tradingGroupId = this.selectedTradingGroupId;
                this.data.productId = this.selectedProductId;
                //this.data.periodStartDate = tradeHelper.fixDateOffset(this.data.periodStartDate);
                //this.data.periodEndDate = tradeHelper.fixDateOffset(this.data.periodEndDate);
                this.data.tradeEntityType = this.showComplex ? 1 : 0;
                this.data.calculatedLockedVolume = parseFloat(this.calculatedLockedVolume);
                this.data.tradedValue = parseFloat(this.data.calculatedLockedVolume *this.data.price);
                /*  this.data.tradeDate = tradeHelper.fixDateOffset(this.data.tradeDate);*/
                this.data.confirmationTradeUrl = this.confirmationTradeFileUrls && this.confirmationTradeFileUrls.length > 0 ? this.confirmationTradeFileUrls.join() : null,
                this.data.currencyId = this.selectedCurrencyId;
                this.data.tradingUnitId = this.selectedTradingUnitId;
                this.data.volumeUnitId = this.selectedVolumeUnitId;
                this.data.pricingAreaId = this.selectedPriceAreaId;
                this.data.currencySymbol = !(this.priceUnit === '') ? this.priceUnit.split("/")[0] : '';
                this.data.tradeableUnit = !(this.priceUnit === '') ? this.priceUnit.split("/")[1] : '';
                let selectedPeriod = this.tradePeriods.filter(tp => { return tp.id === this.selectedTradeablePeriodId })[0];
                var vlms = this.volumes.result.filter(v => { return v.tradablePeriod === selectedPeriod.name && v.year === this.selectedTradeablePeriodYear });
                this.data.volumeId = selectedPeriod.periodId === 2 && vlms.length > 0 ? vlms[0].volumeId : null;
                let productId = this.$refs.dplProducts.ej2Instances.value || this.selectedProductId;
                let product = this.products.filter(p => { return p.id === productId })[0];
                let key = this.normaliseProductName(product.productName);
                let viewModels = {};
                if (this.data.tradeId) {
                    //if complex save child ticket and set price for parent
                    if (this.showComplex) {
                        let tradess = this.getComplexTradeValuesFromGrid(this.selectedContractId, null, this.selectedContractApportionmentId);
                        let viewModel = {};
                        viewModel.trades = tradess;
                        //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                        apis.protectedApi.put(`trade/BulkUpdate`, viewModel, { isDateFix: true })
                            .then(response => {
                                let message = { title: 'Success!', content: 'Child Complex Trades are updated successfully', cssClass: 'e-toast-success' };
                                this.$root.$emit('showToast', message);
                                this.isSubmitting = false;
                                hideSpinner(document.getElementById('mainSpinner'));
                            }).catch(e => {
                                if (e.response) {
                                    this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                    this.isSubmitting = false;
                                    hideSpinner(document.getElementById('mainSpinner'));
                                }
                            });

                        this.data.price = this.customAggregateFn(this.cgTrades);
                        this.data.tradedValue = parseFloat(this.data.calculatedLockedVolume * this.data.price);
                    }
                    //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                    apis.protectedApi.put(`trade`, this.data, { isDateFix: true })
                        .then(response => {
                            let message = { title: 'Success!', content: 'Trade is updated successfully', cssClass: 'e-toast-success' };
                            this.$root.$emit('showToast', message);
                            this.isSubmitting = false;
                            hideSpinner(document.getElementById('mainSpinner'));
                            if (this.callerForm == "ATGReports") {
                                this.$router.push({ name: this.callerForm, params: { tradingGroupId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                            } else {
                                this.$router.push({ name: this.callerForm, params: { contractId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                            }
                        }).catch(e => {
                            if (e.response) {
                                this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                this.isSubmitting = false;
                                hideSpinner(document.getElementById('mainSpinner'));
                            }
                        });
                    //now get child complex tickets

                }


                else{

                    // If trading group is selected, create trade entries for each contract in the trading group
                    if (this.selectedTradingGroupContracts && this.selectedTradingGroupContracts.length > 0) {
                        var dict = {};
                        var noOfContracts = this.selectedTradingGroupContracts.length;
                        var noOfProcessedContracts = 0;
                        var atgTotalLockedVolume = JSON.parse(JSON.stringify(this.data.lockedVolume));

                        var priceData = self.$refs.grid.dataSource.map(({ price, tradePeriodId, tradePeriodSpanId }) => ({ price, tradePeriodId, tradePeriodSpanId }));

                        for (var i = 0; i < this.selectedTradingGroupContracts.length; i++) {

                            dict[this.selectedTradingGroupContracts[i].contractId] =
                                this.selectedTradingGroupContracts[i].contractName;
                            this.data.contractId = this.selectedTradingGroupContracts[i].contractId;
                            this.data.clientId = this.selectedTradingGroupContracts[i].clientId;
                            this.data.companyId = this.selectedTradingGroupContracts[i].companyId;

                            this.updateChildTradesGridValues(this.selectedSplitPeriodInto, this.selectedTradingGroupContracts[i].contractId);

                            let vols = this.atgVolumesPeriodsPerContract.map(cvp => { return cvp.volumes });
                            let allVols = Array.prototype.concat.apply([], vols);

                            this.volumes = { result: allVols };
                            let vlms = this.volumes.result.filter(v => {
                                return v.tradablePeriod === selectedPeriod.name && v.year === this.selectedTradeablePeriodYear && v.contractId === this.selectedTradingGroupContracts[i].contractId
                            });
                            this.data.volumeId = selectedPeriod.periodId === 2 && vlms.length > 0 ? vlms[0].volumeId : null;

                            let ctps = this.atgVolumesPeriodsPerContract.map(cvp => { return cvp.contractTradeablePeriods });
                            let allCtps = null;
                            if (ctps.length > 0) {
                                allCtps = ctps[0];
                            }
                            if (ctps.length > 1) {
                                for (var j = 0; j < ctps.length - 1; j++) {
                                    allCtps = allCtps.concat(ctps[j + 1]);
                                }
                            }

                            this.tradePeriods = allCtps;

                            let tempCTP = this.tradePeriods.filter(ctp => {
                                return this.selectedTradeablePeriodPeriodSpanId > 0 ? ctp.contractId === this.selectedTradingGroupContracts[i].contractId &&
                                    ctp.periodId === this.selectedTradeablePeriodPeriodId &&
                                    ctp.periodSpanId === this.selectedTradeablePeriodPeriodSpanId &&
                                    ctp.year === this.selectedTradeablePeriodYear :
                                    ctp.contractId === this.selectedTradingGroupContracts[i].contractId &&
                                    ctp.periodId === this.selectedTradeablePeriodPeriodId &&
                                    ctp.year === this.selectedTradeablePeriodYear
                            })[0];

                            this.processTradablePeriodChange(tempCTP.id, this.selectedTradingGroupContracts[i].contractId);

                            let atgContractLockedVolume = this.apportionAtgLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, this.data, atgTotalLockedVolume, this.selectedTradingGroupContracts[i].contractId);

                            if (!this.showComplex) {// standard trade is selected
                                this.data.lockedVolume = atgContractLockedVolume;
                                this.setCalculatedLockedVolume(tempCTP.id,atgContractLockedVolume, atgTotalLockedVolume);
                                this.data.calculatedLockedVolume = parseFloat(this.calculatedLockedVolume);
                                this.data.volumeHedgedPercentage = this.contractTradingUnit.tradingName === '%' ?
                                    parseFloat(this.newCalculatePercentage(this.calculatedLockedVolume, this.getProductTotalVolumeByTradeablePeriodId(this.tradePeriods, this.volumes.result,tempCTP.id, false, this.selectedTradingGroupContracts[i].contractId), this.data.periodStartDate, this.data.periodEndDate, true)) :
                                    parseFloat(this.newCalculatePercentage(this.data.calculatedLockedVolume, this.getProductTotalVolumeByTradeablePeriodId(this.tradePeriods, this.volumes.result,tempCTP.id, false, this.selectedTradingGroupContracts[i].contractId), this.data.periodStartDate, this.data.periodEndDate, true));
                                this.data.tradedValue = parseFloat(this.data.calculatedLockedVolume * this.data.price);
                                this.data.contractId = this.selectedTradingGroupContracts[i].contractId;
                                this.data.contractTradeablePeriodId = tempCTP.id;
                                if (selectedPeriod.indicator !== 'M') {
                                    this.data.groupId = uuidv4();
                                    this.data.isGroupParent = true;
                                }
                                if (this.isHypothetical) {
                                    //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                    apis.protectedApi.post(`hypoTrade`, this.data, { isDateFix: true })
                                        .then(response => {
                                            let message = { title: 'Success!', content: `Trade is created successfully for contract ${dict[response.data.contractId]}`, cssClass: 'e-toast-success' };
                                            this.$root.$emit('showToast', message);
                                            this.isSubmitting = false;
                                            hideSpinner(document.getElementById('mainSpinner'));
                                            if (/*selectedPeriod.indicator === 'M'*/ selectedPeriod.periodId == 2 && noOfProcessedContracts == noOfContracts) {
                                                if (this.selectedTradingGroupId != undefined || this.selectedTradingGroupId != null) {
                                                    this.$router.push({ name: "ATGReports", params: { tradingGroupId: this.selectedTradingGroupId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                } else {
                                                    this.$router.push({ name: "Reports UI", params: { contractId: this.selectedContractId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                }
                                            }

                                            //This call is for chlid ATG contracts 05.12.2022 Haris
                                            if (response.status == 200) {
                                                // if the trade is not a monthly trade, create child monthly tickets for that period
                                                //if (selectedPeriod.indicator !== 'M') {
                                                if (selectedPeriod.periodId != 2) {

                                                    //This is second call for list of contracts, first parent then child but same loop must go here, if not [i] does not reach
                                                    for (let i = 0; i < this.selectedTradingGroupContracts.length; i++) {
                                                        let trades = this.getStandardTradeValuesFromGrid(this.selectedTradingGroupContracts[i].contractId);

                                                        let viewModel = {};
                                                        viewModel.trades = trades;

                                                        for (let trade of viewModel.trades) {
                                                            let vlm = this.volumes.result.filter(v => {
                                                                return v.periodSpanId === trade.tradePeriodSpanId && v.year === trade.year && v.contractId === this.selectedTradingGroupContracts[i].contractId;
                                                            })[0];
                                                            trade.periodStartDate = tradeHelper.fixDateOffset(tradeHelper.getStartDateByTradePeriodSpanIdAndYear(vlm.periodSpanId, vlm.year));
                                                            trade.periodEndDate = tradeHelper.fixDateOffset(tradeHelper.getEndDateByTradePeriodSpanIdAndYear(vlm.periodSpanId, vlm.year));

                                                            trade.lockedVolume = this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, trade, atgContractLockedVolume, this.data.periodStartDate, this.data.periodEndDate);
                                                            trade.calculatedLockedVolume = this.calculateLockedVolume(trade.periodStartDate, trade.periodEndDate, vlm[key], 0, trade.lockedVolume, trade, true);
                                                            trade.volumeHedgedPercentage = parseFloat(this.newCalculatePercentage(trade.calculatedLockedVolume, vlm[key], trade.periodStartDate, trade.periodEndDate, true));
                                                            trade.tradedValue = parseFloat(trade.calculatedLockedVolume * this.data.price);

                                                            if (this.contractTradingUnit.tradingName === '%' && this.selectedContractApportionmentId && this.selectedContractApportionmentId === 1) {
                                                                trade.lockedVolume = parseFloat(this.newCalculatePercentage(trade.calculatedLockedVolume, vlm[key], trade.periodStartDate, trade.periodEndDate, true));
                                                            }
                                                        }
                                                        if (this.isHypothetical) {
                                                            //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                                            apis.protectedApi.post(`hypoTrade/Bulk`, viewModel, { isDateFix: true })
                                                                .then(response => {
                                                                    let message = { title: 'Success!', content: `Background simple trades for contract ${dict[response.data.contractId]} are created successfully`, cssClass: 'e-toast-success' };
                                                                    this.$root.$emit('showToast', message);
                                                                    this.isSubmitting = false;
                                                                    hideSpinner(document.getElementById('mainSpinner'));
                                                                    if (noOfProcessedContracts == noOfContracts) {
                                                                        if (this.selectedTradingGroupId != undefined || this.selectedTradingGroupId != null) {
                                                                            this.$router.push({ name: "ATGReports", params: { tradingGroupId: this.selectedTradingGroupId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                                        } else {
                                                                            this.$router.push({ name: "Reports UI", params: { contractId: this.selectedContractId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                                        }
                                                                    }
                                                                }).catch(e => {
                                                                    if (e.response) {
                                                                        this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                                        this.isSubmitting = false;
                                                                        hideSpinner(document.getElementById('mainSpinner'));
                                                                    }
                                                                });
                                                        }
                                                    }

                                                }
                                            }
                                        }).catch(e => {
                                            if (e.response) {
                                                this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                this.isSubmitting = false;
                                                hideSpinner(document.getElementById('mainSpinner'));
                                            }
                                        });
                                }
                                else {
                                    // if the trade is not a monthly trade, create child monthly tickets for that period
                                    //if (selectedPeriod.indicator !== 'M') {

                                    if (selectedPeriod.periodId != 2) {
                                        let viewModel = {};
                                        //This is second call for list of contracts, first parent then child but same loop must go here, if not [i] does not reach
                                        for (let j = 0; j < this.selectedTradingGroupContracts.length; j++) {
                                            let trades = this.getStandardTradeValuesFromGrid(this.selectedTradingGroupContracts[i].contractId);

                                            viewModel.trades = trades;

                                            for (let trade of viewModel.trades) {
                                                let vlm = this.volumes.result.filter(v => {
                                                    return v.periodSpanId === trade.tradePeriodSpanId && v.year === trade.year && v.contractId === this.selectedTradingGroupContracts[i].contractId;
                                                })[0];
                                                trade.periodStartDate = tradeHelper.fixDateOffset(tradeHelper.getStartDateByTradePeriodSpanIdAndYear(vlm.periodSpanId, vlm.year));
                                                trade.periodEndDate = tradeHelper.fixDateOffset(tradeHelper.getEndDateByTradePeriodSpanIdAndYear(vlm.periodSpanId, vlm.year));

                                                trade.lockedVolume = this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, trade, atgContractLockedVolume, this.data.periodStartDate, this.data.periodEndDate);
                                                trade.calculatedLockedVolume = this.calculateLockedVolume(trade.periodStartDate, trade.periodEndDate, vlm[key], 0, trade.lockedVolume, trade, true);
                                                trade.volumeHedgedPercentage = parseFloat(this.newCalculatePercentage(trade.calculatedLockedVolume, vlm[key], trade.periodStartDate, trade.periodEndDate, true));
                                                trade.tradedValue = parseFloat(trade.calculatedLockedVolume * this.data.price);

                                                if (this.contractTradingUnit.tradingName === '%' && this.selectedContractApportionmentId && this.selectedContractApportionmentId === 1) {
                                                    trade.lockedVolume = parseFloat(this.newCalculatePercentage(trade.calculatedLockedVolume, vlm[key], trade.periodStartDate, trade.periodEndDate, true));
                                                }
                                            }

                                        }
                                        viewModels[this.data.contractId] = viewModel;
                                    }
                                    //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                    apis.protectedApi.post(`trade`, this.data, { isDateFix: true })
                                        .then(response => {
                                            let message = { title: 'Success!', content: `Trade is created successfully for contract ${dict[response.data.contractId]}`, cssClass: 'e-toast-success' };
                                            this.$root.$emit('showToast', message);
                                            this.isSubmitting = false;
                                            hideSpinner(document.getElementById('mainSpinner'));
                                            if (/*selectedPeriod.indicator === 'M'*/ selectedPeriod.periodId == 2 && noOfProcessedContracts == noOfContracts) {
                                                if (this.callerForm == "ATGReports") {
                                                    this.$router.push({ name: this.callerForm, params: { tradingGroupId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                                } else {
                                                    this.$router.push({ name: this.callerForm, params: { contractId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                                }
                                            }
                                            //This call is for chlid ATG contracts 05.12.2022 Haris
                                            if (response.status == 200 && selectedPeriod.periodId != 2) {
                                                //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                                apis.protectedApi.post(`trade/Bulk`, viewModels[response.data.contractId], { isDateFix: true })
                                                    .then(response => {

                                                        let message = { title: 'Success!', content: `Background simple trades for contract ${dict[response.data.contractId]} are created successfully`, cssClass: 'e-toast-success' };
                                                        this.$root.$emit('showToast', message);
                                                        this.isSubmitting = false;
                                                        hideSpinner(document.getElementById('mainSpinner'));
                                                        if (noOfProcessedContracts == noOfContracts) {
                                                            if (this.callerForm == "ATGReports") {
                                                                this.$router.push({ name: this.callerForm, params: { tradingGroupId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                                            } else {
                                                                this.$router.push({ name: this.callerForm, params: { contractId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                                            }
                                                        }
                                                    }).catch(e => {
                                                        if (e.response) {
                                                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                            this.isSubmitting = false;
                                                            hideSpinner(document.getElementById('mainSpinner'));
                                                        }
                                                    });

                                           }
                                        }).catch(e => {
                                            if (e.response) {
                                                this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                this.isSubmitting = false;
                                                hideSpinner(document.getElementById('mainSpinner'));
                                            }
                                        });
                                }

                            } else {
                                // complex trade is selected
                                //first save the parent ticket ,the one we see and edit
                                this.data.complexGroupId = uuidv4();
                                let trades = this.getComplexTradeValuesFromGrid(this.selectedTradingGroupContracts[i].contractId, atgContractLockedVolume);
                                this.data.contractTradeablePeriodId = tempCTP.id;
                                this.data.lockedVolume = atgContractLockedVolume;
                                this.setCalculatedLockedVolume(tempCTP.id, atgContractLockedVolume, atgTotalLockedVolume);
                                this.data.calculatedLockedVolume = parseFloat(this.calculatedLockedVolume);
                                this.data.volumeHedgedPercentage = this.contractTradingUnit.tradingName === '%' ?
                                    parseFloat(this.newCalculatePercentage(this.calculatedLockedVolume, this.getProductTotalVolumeByTradeablePeriodId(this.tradePeriods, this.volumes.result, tempCTP.id, false, this.selectedTradingGroupContracts[i].contractId), this.data.periodStartDate, this.data.periodEndDate, true)) :
                                    parseFloat(this.newCalculatePercentage(this.data.calculatedLockedVolume, this.getProductTotalVolumeByTradeablePeriodId(this.tradePeriods, this.volumes.result, tempCTP.id, false, this.selectedTradingGroupContracts[i].contractId), this.data.periodStartDate, this.data.periodEndDate, true));
                                //Haris Test babel issue;
                                for (let trd of trades) {
                                    let volume = this.volumes.result.filter(v => v.volumeId === trd.volumeId)[0];
                                    // until bug 1068, where true flag for child was set to have correct value and then locked volume set to same as percentage. was not sure if the true flag for child should be always so made a check for this scenario,if some more are needed then add or switch entirly to child true flag
                                   // trd.calculatedLockedVolume = volume === 0 ? 0 : parseFloat(this.calculateLockedVolume(trd.periodStartDate, trd.periodEndDate, volume[key], volume[key], trd.lockedVolume, trd, false, this.data.lockedVolume));
                                    trd.calculatedLockedVolume = volume === 0 ? 0 : parseFloat(this.calculateLockedVolume(trd.periodStartDate, trd.periodEndDate, volume[key], volume[key], trd.lockedVolume, trd, (this.contractTradingUnit.tradingName === '%' && this.selectedContractApportionmentId && this.selectedContractApportionmentId === 1)? true: false, this.data.lockedVolume));
                                    trd.tradedValue = parseFloat(trd.calculatedLockedVolume * priceData.filter(pd => { return pd.tradePeriodId === trd.tradePeriodId && pd.tradePeriodSpanId === trd.tradePeriodSpanId })[0].price);
                                    trd.volumeHedgedPercentage = parseFloat(this.newCalculatePercentage(trd.calculatedLockedVolume, volume[key], trd.periodStartDate, trd.periodEndDate, true));
                                    if (this.contractTradingUnit.tradingName === '%' && this.selectedContractApportionmentId && this.selectedContractApportionmentId === 1) {
                                        trd.lockedVolume = parseFloat(this.newCalculatePercentage(trd.calculatedLockedVolume, volume[key], trd.periodStartDate, trd.periodEndDate, true));
                                    }
                                }

                                let viewModel = {};
                                viewModel.trades = trades;

                                this.data.price = this.customAggregateFn(trades);
                                this.data.tradedValue = parseFloat(this.data.calculatedLockedVolume * this.data.price);

                                this.data.tradedValue = this.data.price * this.data.calculatedLockedVolume;
                                this.data.IsComplexGroupParent = true;
                                if (this.isHypothetical) {
                                    //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                    apis.protectedApi.post(`hypoTrade`, this.data, { isDateFix: true })
                                        .then(response => {
                                            let message = { title: 'Success!', content: `Complex Trade is created successfully for contract ${dict[response.data.contractId]}`, cssClass: 'e-toast-success' };
                                            this.$root.$emit('showToast', message);
                                            this.isSubmitting = false;
                                            hideSpinner(document.getElementById('mainSpinner'));
                                            if (/*selectedPeriod.indicator === 'M'*/ selectedPeriod.periodId == 2 && noOfProcessedContracts == noOfContracts) {
                                                if (this.selectedTradingGroupId != undefined || this.selectedTradingGroupId != null) {
                                                    this.$router.push({ name: "ATGReports", params: { tradingGroupId: this.selectedTradingGroupId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                } else {
                                                    this.$router.push({ name: "Reports UI", params: { contractId: this.selectedContractId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                }
                                            }
                                            if (response.status == 200) {
                                                if (this.isHypothetical) {
                                                    //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                                    apis.protectedApi.post(`hypoTrade/Bulk`, viewModel, { isDateFix: true })
                                                        .then(response => {
                                                            let message = { title: 'Success!', content: `Complex child trades for contract ${dict[response.data.contractId]} are created successfully`, cssClass: 'e-toast-success' };
                                                            this.$root.$emit('showToast', message);
                                                            this.isSubmitting = false;
                                                            hideSpinner(document.getElementById('mainSpinner'));
                                                            if (this.selectedSplitPeriodInto === 3 && noOfProcessedContracts === noOfContracts) {
                                                                if (this.selectedTradingGroupId != undefined || this.selectedTradingGroupId != null) {
                                                                    this.$router.push({ name: "ATGReports", params: { tradingGroupId: this.selectedTradingGroupId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                                } else {
                                                                    this.$router.push({ name: "Reports UI", params: { contractId: this.selectedContractId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                                }
                                                            }
                                                        }).catch(e => {
                                                            if (e.response) {
                                                                this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                                this.isSubmitting = false;
                                                                hideSpinner(document.getElementById('mainSpinner'));
                                                            }
                                                        });
                                                }
                                                // for complex trades, if splitPeriodInto is a value other than month (id: 3, see splitPeriodIntoBase array),
                                                // create child monthly tickets for each complex trade
                                                if (this.selectedSplitPeriodInto !== 3) {
                                                    //This is second call for list of contracts, first parent then child but same loop must go here, if not [i] does not reach
                                                    for (let i = 0; i < this.selectedTradingGroupContracts.length; i++) {
                                                        for (let trade of viewModel.trades) {
                                                            trade.lockedVolume = this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, trade, atgContractLockedVolume, this.data.periodStartDate, this.data.periodEndDate, this.selectedContractApportionmentId);

                                                            let tempChildMonthlyTrades = this.getMonthlyVolumesForTradeablePeriod(this.tradePeriods, this.volumes.result, trade.contractTradeablePeriodId, this.selectedTradingGroupContracts[i].contractId);

                                                            // If a complex trade is slit into periods other than months (eg. quarters), each of those periods
                                                            // needs to have it's own child trades created by splitting it into monthly representation by using volumes.
                                                            trade.groupId = uuidv4();
                                                            trade.isGroupParent = true;
                                                            for (let childMonthlyTrade of tempChildMonthlyTrades) {
                                                                childMonthlyTrade.atgTradeId = this.data.atgTradeId;
                                                                childMonthlyTrade.groupId = trade.groupId;
                                                                childMonthlyTrade.isGroupParent = false;
                                                                childMonthlyTrade.price = trade.price;
                                                                childMonthlyTrade.periodStartDate = tradeHelper.getStartDateByTradePeriodSpanIdAndYear(childMonthlyTrade.tradePeriodSpanId, childMonthlyTrade.year);
                                                                childMonthlyTrade.periodEndDate = tradeHelper.getEndDateByTradePeriodSpanIdAndYear(childMonthlyTrade.tradePeriodSpanId, childMonthlyTrade.year);

                                                                childMonthlyTrade.lockedVolume = this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, childMonthlyTrade, trade.lockedVolume, trade.periodStartDate, trade.periodEndDate, this.selectedContractApportionmentId);
                                                                childMonthlyTrade.calculatedLockedVolume = parseFloat(this.calculateLockedVolume(childMonthlyTrade.periodStartDate, childMonthlyTrade.periodEndDate, childMonthlyTrade[key], 0, childMonthlyTrade.lockedVolume, childMonthlyTrade, true));

                                                                this.childMonthlyTrades.push(childMonthlyTrade);
                                                            }
                                                        }
                                                    }
                                                }

                                                // if the condition is true, that means child tickets were generated and need to be saved as well
                                                if (this.selectedSplitPeriodInto !== 3) {
                                                    var childTicketsViewModel = {};
                                                    childTicketsViewModel.trades = this.childMonthlyTrades;
                                                    if (this.isHypothetical) {
                                                        //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                                        apis.protectedApi.post(`hypoTrade/Bulk`, childTicketsViewModel, { isDateFix: true })
                                                            .then(response => {
                                                                let message = { title: 'Success!', content: `Background standard trades for contract ${dict[response.data.contractId]} are created successfully`, cssClass: 'e-toast-success' };
                                                                this.$root.$emit('showToast', message);
                                                                this.isSubmitting = false;
                                                                hideSpinner(document.getElementById('mainSpinner'));
                                                                if (noOfProcessedContracts == noOfContracts) {
                                                                    if (this.selectedTradingGroupId != undefined || this.selectedTradingGroupId != null) {
                                                                        this.$router.push({ name: "ATGReports", params: { tradingGroupId: this.selectedTradingGroupId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                                    } else {
                                                                        this.$router.push({ name: "Reports UI", params: { contractId: this.selectedContractId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                                    }
                                                                }
                                                            }).catch(e => {
                                                                if (e.response) {
                                                                    this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                                    this.isSubmitting = false;
                                                                    hideSpinner(document.getElementById('mainSpinner'));
                                                                }
                                                            });
                                                    }

                                                }

                                            }
                                        }).catch(e => {
                                            if (e.response) {
                                                this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                this.isSubmitting = false;
                                                hideSpinner(document.getElementById('mainSpinner'));
                                            }
                                        });
                                }
                                else {
                                    //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                    apis.protectedApi.post(`trade`, this.data, { isDateFix: true })
                                        .then(response => {
                                            let message = { title: 'Success!', content: `Complex Trade is created successfully for contract ${dict[response.data.contractId]}`, cssClass: 'e-toast-success' };
                                            this.$root.$emit('showToast', message);
                                            this.isSubmitting = false;
                                            hideSpinner(document.getElementById('mainSpinner'));
                                            if (/*selectedPeriod.indicator === 'M'*/ selectedPeriod.periodId == 2 && noOfProcessedContracts == noOfContracts) {
                                                if (this.callerForm == "ATGReports") {
                                                    this.$router.push({ name: this.callerForm, params: { tradingGroupId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                                } else {
                                                    this.$router.push({ name: this.callerForm, params: { contractId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                                }
                                            }
                                            if (response.status == 200) {
                                                //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                                apis.protectedApi.post(`trade/Bulk`, viewModel, { isDateFix: true })
                                                    .then(response => {
                                                        let message = { title: 'Success!', content: `Complex child trades for contract ${dict[response.data.contractId]} are created successfully`, cssClass: 'e-toast-success' };
                                                        this.$root.$emit('showToast', message);
                                                        this.isSubmitting = false;
                                                        hideSpinner(document.getElementById('mainSpinner'));
                                                        if (this.selectedSplitPeriodInto === 3 && noOfProcessedContracts === noOfContracts) {
                                                            if (this.callerForm == "ATGReports") {
                                                                this.$router.push({ name: this.callerForm, params: { tradingGroupId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                                            } else {
                                                                this.$router.push({ name: this.callerForm, params: { contractId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                                            }
                                                        }
                                                    }).catch(e => {
                                                        if (e.response) {
                                                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                            this.isSubmitting = false;
                                                            hideSpinner(document.getElementById('mainSpinner'));
                                                        }
                                                    });
                                                // for complex trades, if splitPeriodInto is a value other than month (id: 3, see splitPeriodIntoBase array),
                                                // create child monthly tickets for each complex trade
                                                if (this.selectedSplitPeriodInto !== 3) {
                                                    //This is second call for list of contracts, first parent then child but same loop must go here, if not [i] does not reach
                                                    for (let i = 0; i < this.selectedTradingGroupContracts.length; i++) {
                                                        for (let trade of viewModel.trades) {
                                                            trade.lockedVolume = this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, trade, atgContractLockedVolume, this.data.periodStartDate, this.data.periodEndDate, this.selectedContractApportionmentId);

                                                            let tempChildMonthlyTrades = this.getMonthlyVolumesForTradeablePeriod(this.tradePeriods, this.volumes.result, trade.contractTradeablePeriodId, this.selectedTradingGroupContracts[i].contractId);

                                                            // If a complex trade is slit into periods other than months (eg. quarters), each of those periods
                                                            // needs to have it's own child trades created by splitting it into monthly representation by using volumes.
                                                            trade.groupId = uuidv4();
                                                            trade.isGroupParent = true;
                                                            for (let childMonthlyTrade of tempChildMonthlyTrades) {
                                                                childMonthlyTrade.atgTradeId = this.data.atgTradeId;
                                                                childMonthlyTrade.groupId = trade.groupId;
                                                                childMonthlyTrade.isGroupParent = false;
                                                                childMonthlyTrade.price = trade.price;
                                                                childMonthlyTrade.periodStartDate = tradeHelper.getStartDateByTradePeriodSpanIdAndYear(childMonthlyTrade.tradePeriodSpanId, childMonthlyTrade.year);
                                                                childMonthlyTrade.periodEndDate = tradeHelper.getEndDateByTradePeriodSpanIdAndYear(childMonthlyTrade.tradePeriodSpanId, childMonthlyTrade.year);

                                                                childMonthlyTrade.lockedVolume = this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, childMonthlyTrade, trade.lockedVolume, trade.periodStartDate, trade.periodEndDate, this.selectedContractApportionmentId);
                                                                childMonthlyTrade.calculatedLockedVolume = parseFloat(this.calculateLockedVolume(childMonthlyTrade.periodStartDate, childMonthlyTrade.periodEndDate, childMonthlyTrade[key], 0, childMonthlyTrade.lockedVolume, childMonthlyTrade, true));

                                                                this.childMonthlyTrades.push(childMonthlyTrade);
                                                            }
                                                        }
                                                    }
                                                }



                                                // if the condition is true, that means child tickets were generated and need to be saved as well
                                                if (this.selectedSplitPeriodInto !== 3) {
                                                    let childTicketsViewModel = {};
                                                    childTicketsViewModel.trades = this.childMonthlyTrades;
                                                        //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                                        apis.protectedApi.post(`trade/Bulk`, childTicketsViewModel, { isDateFix: true })
                                                            .then(response => {

                                                                let message = { title: 'Success!', content: `Background standard trades for contract ${dict[response.data.contractId]} are created successfully`, cssClass: 'e-toast-success' };
                                                                this.$root.$emit('showToast', message);
                                                                this.isSubmitting = false;
                                                                hideSpinner(document.getElementById('mainSpinner'));
                                                                if (noOfProcessedContracts == noOfContracts) {
                                                                    if (this.callerForm == "ATGReports") {
                                                                        this.$router.push({ name: this.callerForm, params: { tradingGroupId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                                                    } else {
                                                                        this.$router.push({ name: this.callerForm, params: { contractId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                                                    }
                                                                }
                                                            }).catch(e => {
                                                                if (e.response) {
                                                                    this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                                    this.isSubmitting = false;
                                                                    hideSpinner(document.getElementById('mainSpinner'));
                                                                }
                                                            });

                                                }

                                            }
                                        }).catch(e => {
                                            if (e.response) {
                                                this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                this.isSubmitting = false;
                                                hideSpinner(document.getElementById('mainSpinner'));
                                            }
                                        });
                                }




                            }
                            noOfProcessedContracts++;
                        }
                    }



                    else { // a single contract is selected, create trade entries for the selected contract
                        // standard trade is selected
                        if (!this.showComplex) {
                            this.data.calculatedLockedVolume = parseFloat(this.calculatedLockedVolume);
                            this.data.tradedValue = parseFloat(this.data.calculatedLockedVolume * this.data.price)
                            if (selectedPeriod.indicator !== 'M') {
                                this.data.groupId = uuidv4();
                                this.data.isGroupParent = true;
                            }
                            if (this.isHypothetical) {
                                //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                apis.protectedApi.post(`hypoTrade`, this.data, { isDateFix: true })
                                    .then(response => {
                                        let message = { title: 'Success!', content: 'Hypothetical trade is created successfully', cssClass: 'e-toast-success' };
                                        this.$root.$emit('showToast', message);
                                        this.isSubmitting = false;
                                        hideSpinner(document.getElementById('mainSpinner'));
                                        if (this.selectedTradingGroupId != undefined || this.selectedTradingGroupId != null) {
                                            this.$router.push({ name: "ATGReports", params: { tradingGroupId: this.selectedTradingGroupId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                        } else {
                                            this.$router.push({ name: "Reports UI", params: { contractId: this.selectedContractId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                        }
                                        if (response.status == 200) {
                                            if (selectedPeriod.indicator !== 'M') {
                                                let viewModel = {};
                                                viewModel.trades = this.getStandardTradeValuesFromGrid();

                                                for (let trade of viewModel.trades) {
                                                    trade.groupId = this.data.groupId;
                                                    trade.isGroupParent = false;
                                                    let vlm = this.volumes.result.filter(v => {
                                                        return v.periodSpanId === trade.tradePeriodSpanId && v.year === trade.year;
                                                    })[0];
                                                    trade.periodStartDate = tradeHelper.fixDateOffset(tradeHelper.getStartDateByTradePeriodSpanIdAndYear(vlm.periodSpanId, vlm.year));
                                                    trade.periodEndDate = tradeHelper.fixDateOffset(tradeHelper.getEndDateByTradePeriodSpanIdAndYear(vlm.periodSpanId, vlm.year));

                                                    trade.lockedVolume = this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, trade, this.data.lockedVolume, this.data.periodStartDate, this.data.periodEndDate, this.selectedContractApportionmentId);
                                                    trade.calculatedLockedVolume = this.calculateLockedVolume(trade.periodStartDate, trade.periodEndDate, vlm[key], 0, trade.lockedVolume, trade, true);

                                                }
                                                if (this.isHypothetical) {
                                                    //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                                    apis.protectedApi.post(`hypoTrade/Bulk`, viewModel, { isDateFix: true })
                                                        .then(response => {
                                                            let message = { title: 'Success!', content: 'Hypothetical background simple trades created successfull', cssClass: 'e-toast-success' };
                                                            this.$root.$emit('showToast', message);
                                                            this.isSubmitting = false;
                                                            hideSpinner(document.getElementById('mainSpinner'));
                                                            if (this.selectedTradingGroupId != undefined || this.selectedTradingGroupId != null) {
                                                                this.$router.push({ name: "ATGReports", params: { tradingGroupId: this.selectedTradingGroupId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                            } else {
                                                                this.$router.push({ name: "Reports UI", params: { contractId: this.selectedContractId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                            }
                                                        }).catch(e => {
                                                            if (e.response) {
                                                                this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                                this.isSubmitting = false;
                                                                hideSpinner(document.getElementById('mainSpinner'));
                                                            }
                                                        });
                                                }
                                            }
                                        }
                                    }).catch(e => {
                                        if (e.response) {
                                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                            this.isSubmitting = false;
                                            hideSpinner(document.getElementById('mainSpinner'));
                                        }
                                    });
                            }
                            else {
                                //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                apis.protectedApi.post(`trade`, this.data, { isDateFix: true })
                                    .then(response => {
                                        let message = { title: 'Success!', content: 'Trade is created successfully', cssClass: 'e-toast-success' };
                                        this.$root.$emit('showToast', message);
                                        this.isSubmitting = false;
                                        hideSpinner(document.getElementById('mainSpinner'));
                                        if (this.callerForm == "ATGReports") {
                                            this.$router.push({ name: this.callerForm, params: { tradingGroupId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                        } else {
                                            this.$router.push({ name: this.callerForm, params: { contractId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                        }
                                        if (response.status == 200) {
                                            if (selectedPeriod.indicator !== 'M') {
                                                let viewModel = {};
                                                viewModel.trades = this.getStandardTradeValuesFromGrid();

                                                for (let trade of viewModel.trades) {
                                                    trade.groupId = this.data.groupId;
                                                    trade.isGroupParent = false;
                                                    let vlm = this.volumes.result.filter(v => {
                                                        return v.periodSpanId === trade.tradePeriodSpanId && v.year === trade.year;
                                                    })[0];
                                                    trade.periodStartDate = tradeHelper.fixDateOffset(tradeHelper.getStartDateByTradePeriodSpanIdAndYear(vlm.periodSpanId, vlm.year));
                                                    trade.periodEndDate = tradeHelper.fixDateOffset(tradeHelper.getEndDateByTradePeriodSpanIdAndYear(vlm.periodSpanId, vlm.year));

                                                    trade.lockedVolume = this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, trade, this.data.lockedVolume, this.data.periodStartDate, this.data.periodEndDate, this.selectedContractApportionmentId);
                                                    trade.calculatedLockedVolume = this.calculateLockedVolume(trade.periodStartDate, trade.periodEndDate, vlm[key], 0, trade.lockedVolume, trade, true);

                                                }
                                                  //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                                    apis.protectedApi.post(`trade/Bulk`, viewModel, { isDateFix: true })
                                                        .then(response => {
                                                            let message = { title: 'Success!', content: 'Background simple trades created successfully', cssClass: 'e-toast-success' };
                                                            this.$root.$emit('showToast', message);
                                                            this.isSubmitting = false;
                                                            hideSpinner(document.getElementById('mainSpinner'));
                                                            if (this.callerForm == "ATGReports") {
                                                                this.$router.push({ name: this.callerForm, params: { tradingGroupId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                                            } else {
                                                                this.$router.push({ name: this.callerForm, params: { contractId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                                            }
                                                        }).catch(e => {
                                                            if (e.response) {
                                                                this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                                this.isSubmitting = false;
                                                                hideSpinner(document.getElementById('mainSpinner'));
                                                            }
                                                        });

                                            }
                                        }
                                    }).catch(e => {
                                        if (e.response) {
                                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                            this.isSubmitting = false;
                                            hideSpinner(document.getElementById('mainSpinner'));
                                        }
                                    });
                            }
                            // if the trade is not a monthly trade, create child monthly tickets for that period

                        } else {
                            // complex trade is selected
                            //first save the parent ticket ,the one we see and edit
                            this.data.complexGroupId = uuidv4();
                            this.data.price = this.customAggregateFn(this.cgTrades);
                            this.data.tradedValue = parseFloat(this.customSumFn(this.cgTrades) * this.data.price)
                            this.data.IsComplexGroupParent = true;
                            if (this.isHypothetical) {
                                //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                apis.protectedApi.post(`hypoTrade`, this.data, { isDateFix: true })
                                    .then(response => {
                                        let message = { title: 'Success!', content: 'Hypothetical Complex Trade is created successfully', cssClass: 'e-toast-success' };
                                        this.$root.$emit('showToast', message);
                                        this.isSubmitting = false;
                                        hideSpinner(document.getElementById('mainSpinner'));
                                        if (this.selectedTradingGroupId != undefined || this.selectedTradingGroupId != null) {
                                            this.$router.push({ name: "ATGReports", params: { tradingGroupId: this.selectedTradingGroupId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                        } else {

                                            this.$router.push({ name: "Reports UI", params: { contractId: this.selectedContractId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                        }
                                        if (response.status == 200) {
                                            //now get child complex tickets
                                            let tradess = this.getComplexTradeValuesFromGrid(this.selectedContractId, null, this.selectedContractApportionmentId);

                                            let viewModel = {};
                                            viewModel.trades = tradess;

                                            // for complex trades, if splitPeriodInto is a value other than month (id: 3, see splitPeriodIntoBase array),
                                            // create child monthly tickets for each complex trade
                                            if (this.selectedSplitPeriodInto !== 3) {
                                                for (let trade of viewModel.trades) {
                                                    trade.lockedVolume = this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, trade, this.data.lockedVolume, this.data.periodStartDate, this.data.periodEndDate, this.selectedContractApportionmentId);

                                                    let tempChildMonthlyTrades = this.getMonthlyVolumesForTradeablePeriod(this.tradePeriods, this.volumes.result, trade.contractTradeablePeriodId);

                                                    // If a complex trade is split into periods other than months (eg. quarters), each of those periods
                                                    // needs to have it's own child trades created by splitting it into monthly representation by using volumes.
                                                    trade.groupId = uuidv4();
                                                    trade.isGroupParent = true;
                                                    for (let childMonthlyTrade of tempChildMonthlyTrades) {
                                                        childMonthlyTrade.groupId = trade.groupId;
                                                        childMonthlyTrade.isGroupParent = false;
                                                        childMonthlyTrade.price = trade.price;
                                                        childMonthlyTrade.periodStartDate = tradeHelper.getStartDateByTradePeriodSpanIdAndYear(childMonthlyTrade.tradePeriodSpanId, childMonthlyTrade.year);
                                                        childMonthlyTrade.periodEndDate = tradeHelper.getEndDateByTradePeriodSpanIdAndYear(childMonthlyTrade.tradePeriodSpanId, childMonthlyTrade.year);

                                                        childMonthlyTrade.lockedVolume = this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, childMonthlyTrade, trade.lockedVolume, trade.periodStartDate, trade.periodEndDate, this.selectedContractApportionmentId);
                                                        childMonthlyTrade.calculatedLockedVolume = this.calculateLockedVolume(childMonthlyTrade.periodStartDate, childMonthlyTrade.periodEndDate, childMonthlyTrade[key], 0, childMonthlyTrade.lockedVolume, childMonthlyTrade, true);

                                                        this.childMonthlyTrades.push(childMonthlyTrade);
                                                    }
                                                }
                                            }
                                            if (this.isHypothetical) {
                                                //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                                apis.protectedApi.post(`hypoTrade/Bulk`, viewModel, { isDateFix: true })
                                                    .then(response => {
                                                        let message = { title: 'Success!', content: 'Hypothetical complex child trades are created successfully', cssClass: 'e-toast-success' };
                                                        this.$root.$emit('showToast', message);
                                                        this.isSubmitting = false;
                                                        hideSpinner(document.getElementById('mainSpinner'));
                                                        if (this.selectedTradingGroupId != undefined || this.selectedTradingGroupId != null) {
                                                            this.$router.push({ name: "ATGReports", params: { tradingGroupId: this.selectedTradingGroupId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                        } else {
                                                            this.$router.push({ name: "Reports UI", params: { contractId: this.selectedContractId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                        }
                                                    }).catch(e => {
                                                        if (e.response) {
                                                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                            this.isSubmitting = false;
                                                            hideSpinner(document.getElementById('mainSpinner'));
                                                        }
                                                    });
                                            }

                                            // if the condition is true, that means child tickets were generated and need to be saved as well
                                            if (this.selectedSplitPeriodInto !== 3) {
                                                let childTicketsViewModel = {};
                                                childTicketsViewModel.trades = this.childMonthlyTrades;
                                                if (this.isHypothetical) {
                                                    //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                                    apis.protectedApi.post(`hypoTrade/Bulk`, childTicketsViewModel, { isDateFix: true })
                                                        .then(response => {
                                                            let message = { title: 'Success!', content: 'Hypothetical background standard trades are created successfully', cssClass: 'e-toast-success' };
                                                            this.$root.$emit('showToast', message);
                                                            this.isSubmitting = false;
                                                            hideSpinner(document.getElementById('mainSpinner'));
                                                            if (this.selectedTradingGroupId != undefined || this.selectedTradingGroupId != null) {
                                                                this.$router.push({ name: "ATGReports", params: { tradingGroupId: this.selectedTradingGroupId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                            } else {
                                                                this.$router.push({ name: "Reports UI", params: { contractId: this.selectedContractId, navigateFrom: "trade", callerTab: "hypothetical" } });
                                                            }
                                                        }).catch(e => {
                                                            if (e.response) {
                                                                this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                                this.isSubmitting = false;
                                                                hideSpinner(document.getElementById('mainSpinner'));
                                                            }
                                                        });
                                                }
                                            }
                                        }
                                    }).catch(e => {
                                        if (e.response) {
                                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                            this.isSubmitting = false;
                                            hideSpinner(document.getElementById('mainSpinner'));
                                        }
                                    });
                            }
                            else {
                                //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                apis.protectedApi.post(`trade`, this.data, { isDateFix: true })
                                    .then(response => {
                                        let message = { title: 'Success!', content: 'Complex Trade is created successfully', cssClass: 'e-toast-success' };
                                        this.$root.$emit('showToast', message);
                                        this.isSubmitting = false;
                                        hideSpinner(document.getElementById('mainSpinner'));

                                        if (response.status == 200) {
                                            //now get child complex tickets
                                            let tradess = this.getComplexTradeValuesFromGrid(this.selectedContractId, null, this.selectedContractApportionmentId);

                                            let viewModel = {};
                                            viewModel.trades = tradess;
                                            // for complex trades, if splitPeriodInto is a value other than month (id: 3, see splitPeriodIntoBase array),
                                            // create child monthly tickets for each complex trade
                                            if (this.selectedSplitPeriodInto !== 3) {
                                                for (let trade of viewModel.trades) {
                                                    trade.lockedVolume = this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, trade, this.data.lockedVolume, this.data.periodStartDate, this.data.periodEndDate, this.selectedContractApportionmentId);

                                                    let tempChildMonthlyTrades = this.getMonthlyVolumesForTradeablePeriod(this.tradePeriods, this.volumes.result, trade.contractTradeablePeriodId);

                                                    // If a complex trade is split into periods other than months (eg. quarters), each of those periods
                                                    // needs to have it's own child trades created by splitting it into monthly representation by using volumes.
                                                    trade.groupId = uuidv4();
                                                    trade.isGroupParent = true;
                                                    for (let childMonthlyTrade of tempChildMonthlyTrades) {
                                                        childMonthlyTrade.groupId = trade.groupId;
                                                        childMonthlyTrade.isGroupParent = false;
                                                        childMonthlyTrade.price = trade.price;
                                                        childMonthlyTrade.periodStartDate = tradeHelper.getStartDateByTradePeriodSpanIdAndYear(childMonthlyTrade.tradePeriodSpanId, childMonthlyTrade.year);
                                                        childMonthlyTrade.periodEndDate = tradeHelper.getEndDateByTradePeriodSpanIdAndYear(childMonthlyTrade.tradePeriodSpanId, childMonthlyTrade.year);

                                                        childMonthlyTrade.lockedVolume = this.apportionLockedVolume(this.tradePeriods, this.volumes.result, this.contractTradingUnit.tradingName, childMonthlyTrade, trade.lockedVolume, trade.periodStartDate, trade.periodEndDate, this.selectedContractApportionmentId);
                                                        childMonthlyTrade.calculatedLockedVolume = this.calculateLockedVolume(childMonthlyTrade.periodStartDate, childMonthlyTrade.periodEndDate, childMonthlyTrade[key], 0, childMonthlyTrade.lockedVolume, childMonthlyTrade, true);

                                                        this.childMonthlyTrades.push(childMonthlyTrade);
                                                    }
                                                }
                                            }
                                            //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                            apis.protectedApi.post(`trade/Bulk`, viewModel, { isDateFix: true })
                                                .then(response => {
                                                    let message = { title: 'Success!', content: 'Complex child trades are created successfully', cssClass: 'e-toast-success' };
                                                    this.$root.$emit('showToast', message);
                                                    this.isSubmitting = false;
                                                    hideSpinner(document.getElementById('mainSpinner'));
                                                    if (this.callerForm == "ATGReports") {
                                                        this.$router.push({ name: this.callerForm, params: { tradingGroupId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                                    } else {
                                                        this.$router.push({ name: this.callerForm, params: { contractId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                                                    }
                                                }).catch(e => {
                                                    if (e.response) {
                                                        this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                        this.isSubmitting = false;
                                                        hideSpinner(document.getElementById('mainSpinner'));
                                                    }
                                                });
                                            // if the condition is true, that means child tickets were generated and need to be saved as well
                                            if (this.selectedSplitPeriodInto !== 3) {
                                                let childTicketsViewModel = {};
                                                childTicketsViewModel.trades = this.childMonthlyTrades;

                                                    //Added by Haris 07.11.2022 {isDateFix: true}, for date json serialization problem, this flag set true will correct offset date
                                                    apis.protectedApi.post(`trade/Bulk`, childTicketsViewModel, { isDateFix: true })
                                                        .then(response => {
                                                            let message = { title: 'Success!', content: `Background standard trades are created successfully`, cssClass: 'e-toast-success' };
                                                            this.$root.$emit('showToast', message);
                                                            this.isSubmitting = false;
                                                            hideSpinner(document.getElementById('mainSpinner'));
                                                        }).catch(e => {
                                                            if (e.response) {
                                                                this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                                                this.isSubmitting = false;
                                                                hideSpinner(document.getElementById('mainSpinner'));
                                                            }
                                                        });

                                            }

                                        }
                                    }).catch(e => {
                                        if (e.response) {
                                            this.showErrorDialog(RMErrorType.default, e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                            this.isSubmitting = false;
                                            hideSpinner(document.getElementById('mainSpinner'));
                                        }
                                    });
                            }


                        }
                    }
                }

            },
            isLockedVolumeValid: function () {
                let isValid = false;
                if (!this.showComplex) {
                    if (this.calculatedLockedVolume > 0 && this.data.lockedVolume > 0) {
                        isValid = true;
                    }
                } else {
                    if (this.data.lockedVolume > 0) {
                        isValid = true;
                        this.cgTrades.forEach(cgTrade => {
                            if (cgTrade <= 0) {
                                isValid = false;
                            }
                        });
                    }
                }
                return isValid;
            },
            isPriceValid: function () {
                let isValid = true;
                if (this.showComplex) {
                    for (let i = 0; i < this.cgTrades.length; i++) {
                        if (!this.cgTrades[i].price || this.cgTrades[i].price <= 0) {
                            isValid = false;
                        }
                    }
                }

                if (!this.showComplex && (!this.data.price || this.data.price <= 0)) {
                    isValid = false;
                }

                return isValid;
            },
            isTradeablePeriodValid: function () {
                return tradeHelper.fixDateOffset(this.data.periodEndDate) < tradeHelper.fixDateOffset(this.data.tradeDate) || tradeHelper.fixDateOffset(this.data.tradeDate) < new Date(2015,1,1) ? false : true;
            },
            btnBackClick: function (e) {
                if (this.isHypothetical) {
                    if (this.selectedTradingGroupId != undefined || this.selectedTradingGroupId != null) {
                        this.$router.push({ name: "ATGReports", params: { tradingGroupId: this.selectedTradingGroupId, navigateFrom: "trade", callerTab: "hypothetical" } });
                    } else {
                        this.$router.push({ name: "Reports UI", params: { contractId: this.selectedContractId, navigateFrom: "trade", callerTab: "hypothetical" } });
                    }
                } else {
                    if (this.callerForm == "ATGReports") {
                        this.$router.push({ name: this.callerForm, params: { tradingGroupId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                    } else {
                        this.$router.push({ name: this.callerForm, params: { contractId: this.callerId, callerForm: this.callerForm, callerTab: this.callerTab } });
                    }
                }

                if (AlertDialog) {
                    AlertDialog.hide();
                }
            },
            showErrorDialog: function (errorType, message, moveVertical = false) {
                let action = this.decideAction(errorType);
                let verticalPosition = moveVertical ? 400 : 200;
                AlertDialog = DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: verticalPosition },
                    okButton: { text: 'OK', click: action() },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
            showOverHedgeWarningDialog: function (message) {
                let verticalPosition = 200;
                AlertDialog = DialogUtility.confirm({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: verticalPosition },
                    okButton: { text: 'OK', click: this.completeSave },
                    cancelButton: { text: 'Cancel', click: this.cancelTrade },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
            decideAction: function (errorType) {
                let action = null;
                switch (errorType) {
                    case RMErrorType.recordDoesNotExist:
                        action = this.btnBackClick;
                        break;
                    case RMErrorType.noVolumesForSelectedPeriod:
                        action = this.resetTradeablePeriod;
                        break;
                    case RMErrorType.noRicForSelectedStateUtilityProduct:
                        action = this.resetTradeFull;
                        break;
                    case RMErrorType.invalidLockedVolume:
                        action = function () { return };
                        break;
                    case RMErrorType.invalidPrice:
                        action = function () { return };
                        break;
                    case RMErrorType.tradePeriodPassed:
                        action = function () { return };
                        break;
                    case RMErrorType.default:
                        action = function () { return };
                        break;
                    default:
                        action = this.resetTrade;
                        break;
                }

                return action;
            },
            cancelTrade: function () {
                if (AlertDialog) {
                    this.isSubmitting = false;
                    AlertDialog.hide();
                }
            }
        },
        provide: {
            grid: [Page, Aggregate, Edit, Toolbar, Resize, ForeignKey]
        }
    }
</script>

<style>
    li {
        list-style: none;
    }

    #tradeMainForm .e-control-wrapper .e-file-select,
    .e-control-wrapper .e-file-drop {
        display: none;
    }

    #tradeMainForm .e-upload-success {
        display: none;
    }

    #tradeMainForm .e-upload-files {
        display: none;
    }

    .uploder-trade-file {
        border: none !important;
        text-align: center;
        display: block !important;
    }

    .required-input .e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
    }

    .e-radio-wrapper {
        padding-right: 10px;
        padding-left: 10px;
    }

    #btnRemoveTradeFile {
        padding-right: 4px;
        padding-left: 4px;
        margin-right: 4px !important;
        margin-left: 4px !important;
    }

    #btnDownloadTradeFile {
        padding-right: 4px;
        padding-left: 4px;
        margin-right: 4px !important;
        margin-left: 4px !important;
    }
</style>